import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderService } from 'src/app/services/order.service';
import { DateFormetService } from 'src/app/services/dateFormet.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { StorageService } from 'src/app/services/storage.service';
import { FeatureFlagService } from 'src/app/core/services/feature-flag.service';
import moment from 'moment';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DataTransferService } from 'src/app/doqfy-components/cat-edit/data-transfer.service';
import { ComposePreviewService } from 'src/app/services/compose-preview.service';
import * as bootstrap from 'bootstrap';
import {
  SignatureState,
  SignatureStateService,
} from 'src/app/services/signature-state.service';
import { Subscription } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { AUTO_SIGNATURE_CONSTANTS } from 'src/app/models/e-sign-details.constants';
import { PredefinedReferenceMarker } from 'src/app/shared-components/drag-drop/drag-drop.component';
import { PDFDocument } from 'pdf-lib';
import {
  SIGNATURE_BOX_HEIGHT_PT,
  SIGNATURE_BOX_WIDTH_PT,
} from 'src/app/shared-components/signature-box.util';
import { getStandardSignatureRect } from 'src/app/shared-components/signature-position.util';

export function customEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const valid = emailRegex.test(control.value);
    return valid ? null : { invalidEmail: true };
  };
}

const DRAG_DROP = 'DRAG_DROP';
// const DEFAULT = 'DEFAULT';
interface Position {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
}

interface Option {
  CONSTITUTION: string;
  CONTRACT_RELATION: string;
  PAN: string;
  PARTY_TYPE: string;
}

@Component({
    selector: 'app-e-sign-details',
    templateUrl: './e-sign-details.component.html',
    styleUrls: ['./e-sign-details.component.scss'],
    standalone: false
})
export class ESignDetailsComponent implements OnInit {
  @Input() esignData: any = [];
  @Output() esignDataChange: EventEmitter<any> = new EventEmitter<[]>();
  @Input() uploadFileData: any;
  @Output() uploadFileChange = new EventEmitter<any>();
  @Input() showESignOptions: boolean = false;
  @Input() service: string = '';
  @Output() draftChange = new EventEmitter<boolean>();
  @ViewChild('confirmationModal') confirmationModal!: TemplateRef<any>;
  @ViewChildren('signatoryRow') signatoryRows!: QueryList<
    ElementRef<HTMLElement>
  >;
  @ViewChildren('witnessRow') witnessRows!: QueryList<ElementRef<HTMLElement>>;
  private readonly REORDER_ANIMATION_MS = 260;
  private reorderAnimations = new Map<HTMLElement, Animation>();
  dragDropSignerNames: any;
  @Input() set triggerPopulate(val: boolean) {
    if (val) {
      this.checkAndPopulateDraft();
    }
  }

  isDraft = false;
  isDraftLoading: boolean = false;
  currentOrderId: number | null = null;
  states: any;
  selectedState: any;
  esignDetails!: FormGroup;
  estampLength: any;
  readOnlyName: any = [];
  submitted: boolean = false;
  showSigningDetails: boolean = false;
  showPartyDetails: boolean = true;
  public phonePattern: string = '[0-9]{10}';
  eSignProviderData = [];
  showPichainSign!: boolean;
  showDragDrop!: boolean;
  displaySigningPositions: any = [];
  signatoryAvailablePositions: any[][] = [];
  ElectronicPostionDetails: any = [];
  AadhaarPostionDetails: any = [];
  filteredOptions: any[] = [];
  currentDate = new Date();
  contractType: boolean = false;
  formData: any = [];
  dynamicForm: FormGroup;
  selectedValue: any;
  remainderDays = [
    { name: '1 Day', value: 1 },
    { name: '3 Days', value: 3 },
    { name: '1 Week', value: 7 },
    { name: '10 Days', value: 10 },
  ];
  signPlacementNomal = [
    { name: 'Pre-Defined', value: 'NORMAL', disabled: false },
    { name: 'Custom (Drag & Drop)', value: DRAG_DROP, disabled: false },
    //{ name: 'Default', value: DEFAULT, disabled: false },
  ];

  signPages = [
    { name: 'ALL Pages', code: 'ALL' },
    { name: 'First Page Only', code: 'FIRST' },
    { name: 'Last Page Only', code: 'Last' },
  ];
  signMethod = [
    { name: 'Aadhaar', code: 'AADHAAR', inactive: false },
    { name: 'Electronic', code: 'ELECTRONIC', inactive: false },
    { name: 'DSC', code: 'DSC', inactive: false },
    // USB-Token
  ];
  aadhaarVerificationMethod = [
    { name: 'OTP', code: 'OTP', inactive: false },
    { name: 'Biometric', code: 'Fingerprint', inactive: false },
    { name: 'Face Recognition', code: 'FaceRecognition', inactive: false },
  ];
  isEsigned: boolean = true;
  showWitnessDetails: boolean = false;
  showSignaotryDetails: boolean = true;
  showTemplatePage: boolean = false;
  showPaymentDetails: boolean = false;
  esignedYes: boolean = true;
  esignedNo: boolean = false;
  orderSortYes: boolean = true;
  orderSortNo: boolean = false;
  scheduleMailYes: boolean = false;
  scheduleMailNo: boolean = true;
  signedDocumentYes: boolean = true;
  signedDocumentNo: boolean = false;
  sendNotificationYes: boolean = true;
  sendNotificationNo: boolean = false;
  estampSignYes: boolean = true;
  estampSignNo: boolean = false;
  isPaymentbySignerYes: boolean = false;
  isPaymentbySignerNo: boolean = false;
  isPayNowOrLater: boolean = false;
  isPayNow: boolean = true;
  isPayLater: boolean = false;
  paymentbySignerYes: boolean = true;
  paymentbySignerNo: boolean = false;
  paymentbyWallet: string = 'wallet';
  paymentbyRazorpay: string = 'razorpay';
  payLater: string = 'payLater';
  signPlacment: any = [];
  payLoadObject: any;
  isSignaturePlacementDone: boolean | undefined;
  signerNames: any = [];
  signPlacementDetails: any = {};
  private signPlacementSnapshot: any = null;
  placeSignPostion: any = {};
  templateFileData: any;
  pdfSource: any;
  showCatEdit: boolean = false;
  showPlaceOrder: boolean = false;
  showPredefined: any = [];
  // showSelectPage:any = []
  showPredefinedWitness: any = [];
  showSignMethod: any = [];
  order_count: number = 1;
  displayOrderIndex: boolean = false;
  positionData: any = {};
  selectedSignPositions: any = [];
  showMethod: any = [];
  displayMailSchedule: boolean | undefined;
  minDate: string[] = [];
  esign_default_fields: any;
  account_id: string | undefined;
  default: boolean | undefined;
  custom: boolean | undefined;
  //isDefault: boolean = this.storageService.getEsignDefault();
  isDefault: boolean = false;
  otp_validation: boolean = false;
  stampSignToggle: boolean = false;
  documentToBeStamped: boolean = true;
  showESignSettings: boolean = false;
  maxDate: string;
  scheduleError: boolean[] = [false];
  selectedDateValue: string[] = [];
  showPayment: any;
  is_wallet: boolean = false;
  signProviders: any;
  showSignMode: boolean = false;
  showSchedule: boolean = false;
  selectedOptions: any = []; // Store selected values per key
  sameEsignValues: boolean = false;
  orderControl = new FormControl(false);
  savedData: any = {};
  aadhaar_validation: any;
  selectedSignMethod: string = '';
  selectedAadhaarVerificationMethod: string = '';
  totalPages: number = 0;
  pageHeight: number[] | undefined;
  isDocumentType: string = '003';
  carboncopyYes: boolean = false;
  carboncopyNo: boolean = true;
  pagesArray: number[] = [];
  isCarbonCopy: boolean = false;
  additionalEmailFields: number[] = [];
  carbonCopyCount = 1;
  maxEmails: number = 2;
  walletBalance: any;
  carbonCopyControlsCount: number = 1; // Track the count for better performance
  private activeCarbonCopyControls: string[] = ['carbon_copy_0'];
  private emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
  serverSideYes: boolean = true;
  serverSideNo: boolean = false;
  disableDefaultSignature: boolean | undefined;
  isAutoEsign: boolean = false;
  electronicMethod: boolean | undefined;
  sequentialSign: boolean | undefined;
  hideSequentialSignature: boolean | undefined;
  currentSignatoryIndex: number = -1;
  isStampPreProcured: boolean = false;
  hidePaymentMethod: boolean = false;
  isAbclMidMarket: boolean = false;
  private signatureStateSubscription: Subscription | undefined;
  signatureStates: Map<number, SignatureState> = new Map();
  // Read-only markers handed to the drag & drop screen so positions already
  // fixed through Pre-Defined placement stay visible while placing a custom box.
  predefinedReferenceMarkers: PredefinedReferenceMarker[] = [];
  isInfiniteCorp: boolean = false;

  // Read live on every check (not cached at construction time) so a toggle
  // flipped in Account Settings — in this tab or another — is reflected
  // immediately without needing this component to be freshly constructed.
  get isAuthorisedSignatureEnabled(): boolean {
    return this.featureFlagService.isOrgFeatureEnabled('authorisedSignature');
  }
  isDefaultSignatureSelected: boolean = false;

 readonly defaultAadhaarPositions = [
    'BOTTOM_LEFT',
    'BOTTOM_LEFT_MIDDLE',
    'BOTTOM_CENTRE',
    'BOTTOM_RIGHT_MIDDLE',
    'BOTTOM_RIGHT',
    'BOTTOM_LEFT_2',        
    'BOTTOM_LEFT_MIDDLE_2',  
    'BOTTOM_CENTRE_2',       
    'BOTTOM_RIGHT_MIDDLE_2', 
    'BOTTOM_RIGHT_2'         
  ];

  readonly defaultElectronicPositions = [
    'BOTTOM_LEFT',
    'BOTTOM_LEFT_MIDDLE',
    'BOTTOM_CENTRE',
    'BOTTOM_RIGHT_MIDDLE',
    'BOTTOM_RIGHT',
    'BOTTOM_LEFT_2',         
    'BOTTOM_LEFT_MIDDLE_2',  
    'BOTTOM_CENTRE_2',       
    'BOTTOM_RIGHT_MIDDLE_2', 
    'BOTTOM_RIGHT_2'         
  ];


  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private messageService: MessageService,
    private _location: Location,
    private orderService: OrderService,
    private dateFormetService: DateFormetService,
    private userDashboardService: UserDashboardService,
    private storageService: StorageService,
    private featureFlagService: FeatureFlagService,
    private catUploadService: CatUploadService,
    private dataTransferService: DataTransferService,
    private route: ActivatedRoute,
    private signatureStateService: SignatureStateService,
    private composePreviewService: ComposePreviewService,
    private cdr: ChangeDetectorRef,
  ) {
    this.savedData = this.catUploadService.getEsignFormData();
    this.isInfiniteCorp = this.featureFlagService.isOrgFeatureEnabled('defaultEsign');
    // Check multiple estamp for document
    this.route.queryParams.subscribe((params) => {
      const service = params['service'] || '';
      if (service && service.toUpperCase() == 'MULTIPLE-STAMP') {
        this.service = 'MULTIPLE-STAMP';
      } else {
        this.service = '';
      }
    });
    this.otp_validation = this.storageService.getOtpValidation() ? true : false;
    this.showPayment = this.storageService.getOrderPayment() || null;
    this.stampSignToggle = this.storageService.getStampSignatory() ? true : false;
    const isEsignOnlyRoute =
      this._location.path() === '/doqfy/e-sign/form';
    if (isEsignOnlyRoute) {
      this.documentToBeStamped = false;
      this.storageService.setDocumentToBeStamped(false);
    } else {
      const documentToBeStamped = this.storageService.getDocumentToBeStamped();
      this.documentToBeStamped =
        documentToBeStamped === null ? true : documentToBeStamped;
    }

    //--------- ----> desableing drag and drop for doc and docx
    this.setInitialSignPlacement();
    this.dynamicForm = this.formBuilder.group({});

    this.esignDetails = this.formBuilder.group({
      addPartyDetailsForm: this.formBuilder.array([]),
      addWitnessDetailsForm: this.formBuilder.array([]),
      toBeESigned: [true, [Validators.required]],
      eSignProvider: [''],
      paymentbySigner: [false, [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      amountToPay: [''],
      payeeName: [''],
      payeeEmail: [
        '',
        [
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      payeeMobileNumber: [
        '',
        [
          Validators.pattern(this.phonePattern),
          Validators.maxLength(10),
          Validators.minLength(10),
        ],
      ],
      payNowOrLater: [false, [Validators.required]],
      setOrder: [true, [Validators.required]],
      setMailSchedule: [true, [Validators.required]],
      toBeDefault: [this.isDefault, [Validators.required]],
      setCarbonCopy: [false],
      addDefaultSignature: [false],
      carbon_copy_0: ['', []],
    });

    this.minDate[0] = this.formatDate(this.currentDate);
    this.selectedDateValue[0] = moment(new Date(this.currentDate)).format(
      'lll',
    );

    this.maxDate = this.formatDateEnd(this.currentDate);
    this.aadhaar_validation = this.storageService.getAdharEdit() || null;

    this.displaySigningPositions = [
      {
        display_name: 'Top Left',
        position_code: 'TOP_LEFT',
        id: 1,
        disabled: false,
      },
      {
        display_name: 'Top Centre',
        position_code: 'TOP_CENTRE',
        id: 2,
        disabled: false,
      },
      {
        display_name: 'Top Right',
        position_code: 'TOP_RIGHT',
        id: 3,
        disabled: false,
      },
      {
        display_name: 'Middle Left',
        position_code: 'MIDDLE_LEFT',
        id: 4,
        disabled: false,
      },
      {
        display_name: 'Middle Right',
        position_code: 'MIDDLE_RIGHT',
        id: 5,
        disabled: false,
      },
      {
        display_name: 'Bottom Left',
        position_code: 'BOTTOM_LEFT',
        id: 6,
        disabled: false,
      },
      {
        display_name: 'Bottom Centre',
        position_code: 'BOTTOM_CENTRE',
        id: 7,
        disabled: false,
      },
      {
        display_name: 'Bottom Right',
        position_code: 'BOTTOM_RIGHT',
        id: 8,
        disabled: false,
      },
      {
        display_name: 'Bottom Left Middle',
        position_code: 'BOTTOM_LEFT_MIDDLE',
        id: 9,
        disabled: false,
      },
      {
        display_name: 'Bottom Right Middle',
        position_code: 'BOTTOM_RIGHT_MIDDLE',
        id: 10,
        disabled: false,
      },
    ];
    
    this.ElectronicPostionDetails = [

      { position: 'BOTTOM_LEFT_2',         loc: { x1: 5,   x2: 118, y1: 660, y2: 720 } },
      { position: 'BOTTOM_LEFT_MIDDLE_2',  loc: { x1: 123, x2: 236, y1: 660, y2: 720 } },
      { position: 'BOTTOM_CENTRE_2',       loc: { x1: 241, x2: 354, y1: 660, y2: 720 } },
      { position: 'BOTTOM_RIGHT_MIDDLE_2', loc: { x1: 359, x2: 472, y1: 660, y2: 720 } },
      { position: 'BOTTOM_RIGHT_2',        loc: { x1: 477, x2: 590, y1: 660, y2: 720 } },

      { position: 'BOTTOM_LEFT', loc: { x1: 5, y1: 740, x2: 165, y2: 810 } },
      {
        position: 'BOTTOM_CENTRE',
        loc: { x1: 225, y1: 740, x2: 375, y2: 810 },
      },
      {
        position: 'BOTTOM_CENTER',
        loc: { x1: 225, y1: 740, x2: 375, y2: 810 },
      },
      { position: 'BOTTOM_RIGHT', loc: { x1: 460, y1: 740, x2: 620, y2: 810 } },
      {
        position: 'BOTTOM_LEFT_MIDDLE',
        loc: { x1: 165, y1: 740, x2: 225, y2: 810 },
      },
      {
        position: 'BOTTOM_RIGHT_MIDDLE',
        loc: { x1: 375, y1: 740, x2: 460, y2: 810 },
      },
      { position: 'MIDDLE_LEFT', loc: { x1: 5, y1: 425, x2: 165, y2: 500 } },
      { position: 'MIDDLE_RIGHT', loc: { x1: 462, y1: 425, x2: 622, y2: 500 } },
      { position: 'TOP_LEFT', loc: { x1: 5, y1: 50, x2: 165, y2: 120 } },
      { position: 'TOP_CENTRE', loc: { x1: 225, y1: 50, x2: 375, y2: 120 } },
      { position: 'TOP_CENTER', loc: { x1: 225, y1: 50, x2: 375, y2: 120 } },
      { position: 'TOP_RIGHT', loc: { x1: 460, y1: 50, x2: 620, y2: 120 } },
    ];
    this.AadhaarPostionDetails = [
     
      { position: 'BOTTOM_LEFT_2',  loc: { x1: 5,   x2: 118, y1: 70, y2: 120 } },
      { position: 'BOTTOM_LEFT_MIDDLE_2',  loc: { x1: 123, x2: 236, y1: 70, y2: 120 } },
      { position: 'BOTTOM_CENTRE_2',  loc: { x1: 241, x2: 354, y1: 70, y2: 120 } },
      { position: 'BOTTOM_RIGHT_MIDDLE_2', loc: { x1: 359, x2: 472, y1: 70, y2: 120 } },
      { position: 'BOTTOM_RIGHT_2',  loc: { x1: 477, x2: 590, y1: 70, y2: 120 } },

      { position: 'BOTTOM_LEFT',  loc: { x1: 5,   x2: 118, y1: 5,  y2: 55  } },
      { position: 'BOTTOM_LEFT_MIDDLE', loc: { x1: 123, x2: 236, y1: 5,  y2: 55  } },
      { position: 'BOTTOM_CENTRE',   loc: { x1: 241, x2: 354, y1: 5,  y2: 55  } },
      { position: 'BOTTOM_RIGHT_MIDDLE',   loc: { x1: 359, x2: 472, y1: 5,  y2: 55  } },
      { position: 'BOTTOM_RIGHT',  loc: { x1: 477, x2: 590, y1: 5,  y2: 55  } },
      { position: 'MIDDLE_RIGHT', loc: { x1: 471, x2: 590, y1: 396, y2: 446 } },
      { position: 'MIDDLE_LEFT', loc: { x1: 5, x2: 124, y1: 396, y2: 446 } },
      { position: 'TOP_LEFT', loc: { x1: 5, x2: 124, y1: 787, y2: 837 } },
      { position: 'TOP_CENTRE', loc: { x1: 238, x2: 357, y1: 787, y2: 837 } },
      { position: 'TOP_CENTER', loc: { x1: 238, x2: 357, y1: 787, y2: 837 } },
      { position: 'TOP_RIGHT', loc: { x1: 471, x2: 590, y1: 787, y2: 837 } },
    ];
    this.contractType =
      this.storageService.getContractType() === true &&
      String(this.storageService.getContractNumber()) === '002';
    if (this.contractType === true) {
      this.displaySigningPositions = this.displaySigningPositions.filter(
        (position) =>
          position.position_code !== 'BOTTOM_LEFT_MIDDLE' &&
          position.position_code !== 'BOTTOM_RIGHT_MIDDLE',
      );
    }
    this.getEsignAddionalFields();
    this.is_wallet = this.storageService.getIsWallet();
    this.walletBalance = this.storageService.getWalletBalance();

    this.storageService.processType$.subscribe((processType) => {
      let estampProcessType = processType;
      this.isStampPreProcured = estampProcessType === 'PRE_PROCUREMENT';
    });
    this.storageService.abclMidMarket$.subscribe(() => {
      this.isAbclMidMarket = this.featureFlagService.isAbclMidMarket();
      if (this.isAbclMidMarket) {
        this.signMethod = [
          { name: 'Aadhaar', code: 'AADHAAR', inactive: false },
        ];
        const partyArray = this.esignDetails.get('addPartyDetailsForm') as FormArray;
        partyArray.controls.forEach((control) => {
          control.get('method')?.patchValue('AADHAAR');
        });
      }
    });
  }

  ngOnInit() {
    const service = this.route.snapshot.queryParamMap.get('service');
    this.checkCloudSign();
    this.storageService.isDocumentType$.subscribe((type) => {
      this.isDocumentType = type;
    });

    this.orderControl.valueChanges.subscribe((value) => {
      this.displayOrderIndex = value;
      this.sequentialSign = value;
      if (value) {
        this.hideScheduleEmail();
      } else {
        this.displayOrderIndex = false;
      }
    });
    const currentPath = this._location.path();
    if (currentPath == '/doqfy/cat-edit/form') {
      this.showCatEdit = true;
      this.detectTemplatePageCount();
    } else {
      this.showCatEdit = false;
    }

    this.account_id = this.storageService.getAccountId() || null;

    this.signProviders = this.storageService.getSignProvider() || null;
    this.showSignMode = this.signProviders.includes('EMUDHRA');
    if (this.signProviders) {
      this.showSchedule =
        this.signProviders.includes('DOQFY') &&
        this.signProviders.includes('CAPRICORN');
    }

    this.esignDetails.valueChanges.subscribe((resp) => {
      this.getActivePlaceOrder();
    });

    this.isDefault = this.featureFlagService.isOrgFeatureEnabled('esignDefault');

    if (this.isDefault === true && !this.savedData) {
      this.default = true;
      this.getDefaultFieldData(this.account_id);
    } else {
      this.custom = true;
    }
    this.getESignDefaultDetails();

    this.setupCarbonCopySubscription();
    this.isAutoEsign = this.storageService.getAutoEsignEdit();

    this.signatureStateSubscription =
      this.signatureStateService.signatureStates$.subscribe((states) => {
        this.signatureStates = states;
      });
    let providers = this.getAvailableProviders();
    let paymentOption: any;
    let providerCode: string = 'RAZORPAY_GATEWAY';
    if (this.is_wallet) {
      paymentOption = this.paymentbyWallet;
    } else if (providers.includes('RAZORPAY_GATEWAY') && this.showPayment) {
      paymentOption = this.paymentbyRazorpay;
      providerCode = 'RAZORPAY_GATEWAY';
    } else if (providers.includes('HDFC_GATEWAY') && this.showPayment) {
      paymentOption = 'HDFC_GATEWAY';
      providerCode = 'HDFC_GATEWAY';
    } else {
      paymentOption = this.payLater;
    }
    this.esignDetails.controls.paymentMethod.setValue(paymentOption);
    this.storageService.setSelectedProvider(providerCode);
    if (paymentOption === this.payLater) {
      this.esignDetails.controls.paymentbySigner.setValue(false);
      this.storageService.getSignerValue.next(false);
    } else {
      if (
        paymentOption === this.paymentbyRazorpay ||
        paymentOption === 'HDFC_GATEWAY'
      ) {
        this.showPaymentDetails = true;
      }
      this.esignDetails.controls.paymentbySigner.setValue(true);
      this.storageService.getSignerValue.next(true);
    }

    if (this.savedData?.addPartyDetailsForm?.length > 0) {
      setTimeout(() => {
        this.savedData.addPartyDetailsForm.forEach((savedParty, index) => {
          if (savedParty.sign_position) {
            // Determine if it's NORMAL, DRAG_DROP, or a position code
            let placementType = '';
            let signPosition = '';

            if (savedParty.sign_position === 'DRAG_DROP') {
              // It's DRAG_DROP
              placementType = 'DRAG_DROP';
              this.showPredefined[index] = false;
              //this.showSelectPage[index] = false;
            } else if (savedParty.sign_position === 'NORMAL') {
              // It's NORMAL without a specific position
              placementType = 'NORMAL';
              this.showPredefined[index] = true;
              //this.showSelectPage[index] = true;
            } else {
              // It's a position code (TOP_LEFT, BOTTOM_RIGHT, etc.)
              //placementType = 'DEFAULT';
              signPosition = savedParty.sign_position;
              this.showPredefined[index] = false;
              //this.showSelectPage[index] = true;
            }

            // Restore signPlacementDetails for DRAG_DROP
            if (
              savedParty.sign_position === DRAG_DROP &&
              savedParty.position_details
            ) {
              Object.keys(savedParty.position_details).forEach((pageKey) => {
                if (!this.signPlacementDetails[pageKey]) {
                  this.signPlacementDetails[pageKey] = [];
                }

                while (this.signPlacementDetails[pageKey].length <= index) {
                  this.signPlacementDetails[pageKey].push({
                    id: this.signPlacementDetails[pageKey].length + 1,
                    signBoxList: [],
                  });
                }

                const positionArray = savedParty.position_details[pageKey];
                if (positionArray && positionArray.length > 0) {
                  const signBoxList = positionArray.map((pos, boxIndex) => ({
                    id: `${index + 1}_${pageKey}_${boxIndex + 1}`,
                    globalId: `${index + 1}_${pageKey}_${boxIndex + 1}`,
                    position: pos, // Use position directly from saved data
                    pageNumber: parseInt(pageKey),
                  }));

                  this.signPlacementDetails[pageKey][index] = {
                    id: index + 1,
                    signBoxList: signBoxList,
                    name: savedParty.name,
                    dimension: { height: 842, width: 595 },
                  };

                  this.signatureStateService.updateSignatureState(
                    index,
                    true,
                    signBoxList.length,
                  );

                  const formGroup = this.partyDetailsArray().at(index);
                  if (formGroup) {
                    formGroup.get('isSignaturePlacementDone')?.setValue(true);
                  }
                }
              });
            }
          }
        });

        // Initialize placement type for all restored signatories
        for (let i = 0; i < this.savedData.addPartyDetailsForm.length; i++) {
          this.getPlacementType(i);
        }

        this.cdr?.detectChanges();
      }, 100);
    }

    const draftData = this.storageService.getDraftData();
    const isEditMode = this.route.snapshot.queryParamMap.get('orderId');
    if (isEditMode && draftData && draftData.content) {
      this.currentOrderId = draftData.content.order.id;
      this.checkAndPopulateDraft();
    } else {
      this.currentOrderId = null;
    }
  }

  setInitialSignPlacement() {
    const filetype = this.storageService.getfileType();
    if (filetype === 'doc' || this.service == 'MULTIPLE-STAMP') {
      this.signPlacementNomal = [
        { name: 'Pre-Defined', value: 'NORMAL', disabled: false },
      ];
    } else {
      this.signPlacementNomal = [
        { name: 'Pre-Defined', value: 'NORMAL', disabled: false },
        { name: 'Custom (Drag & Drop)', value: DRAG_DROP, disabled: false } // Assuming DRAG_DROP is a constant
      ];
    }
  }

  onToggleDefaultSignature(targetValue: boolean, event: Event) {
    if (this.isDefaultSignatureSelected === targetValue) {
      return;
    }

    // 1. Check if they have more than 1 signatory row
    const hasMultipleRows = this.partyDetailsArray().length > 1;

    // 2. Check if the FIRST row has any data typed into it
    const firstParty = this.partyDetailsArray().at(0);
    const firstRowHasData = firstParty && (
      firstParty.get('name')?.value?.trim() || 
      firstParty.get('email')?.value?.trim() || 
      firstParty.get('contact_number')?.value?.trim()
    );

    // If EITHER condition is true, show the warning modal
    if (hasMultipleRows || firstRowHasData) {
      
      event.preventDefault();
      this.modalService.open(this.confirmationModal, { centered: true, backdrop: 'static' }).result.then(
        (result) => {
          if (result === 'Okay') {
            // User confirmed: Remove all rows except the first one (Index 0)
            while (this.partyDetailsArray().length > 1) {
              this.partyDetailsArray().removeAt(1);
            }
            
            // Proceed to apply the new signature placement settings to the remaining first row
            this.setDefaultSignature(targetValue);
          }
        },
        (reason) => {
          // User clicked Cancel: Do nothing. The radio button stays on its previous value.
        }
      );
    } else {
      this.setDefaultSignature(targetValue);
    }
  }

  setDefaultSignature(value: boolean) {
      this.isDefaultSignatureSelected = value;
      this.esignDetails.get('addDefaultSignature')?.setValue(value);

      const partyArray = this.esignDetails.get('addPartyDetailsForm') as FormArray;

      if (value) {
        partyArray.controls.forEach(control => {
          control.get('signature_placement_type')?.setValue('DEFAULT');
          control.get('sign_position')?.setValue('DEFAULT'); 
        });

        this.signPlacementNomal = [
          { name: 'Default', value: 'DEFAULT', disabled: false }
        ];
        
      } else {
        partyArray.controls.forEach(control => {
          control.get('signature_placement_type')?.setValue(null);
          control.get('sign_position')?.setValue(null); 
        });

        this.setInitialSignPlacement();
        this.updatePredefinedOptionState(); 
      }
  }

  checkCloudSign() {
    const isCloudSignEnabled = this.featureFlagService.isOrgFeatureEnabled('cloudSign');

    if (isCloudSignEnabled) {
      this.signMethod.push({
        name: 'Cloud Sign',
        code: 'CLOUD_SIGN', // Or the specific code your backend expects
        inactive: false,
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // CAT Compose can populate pdfData after this shared component is created.
    // Load the rendered PDF page count whenever that input becomes available.
    if (
      changes['esignData'] &&
      this.isCatComposeRoute() &&
      this.esignData?.pdfData
    ) {
      this.detectTemplatePageCount();
    }

    if (changes['esignData'] && this.esignData?.totalPages) {
      this.totalPages = this.esignData.totalPages;

      // Update validators for all dynamic partyDetailsArray controls
      this.partyDetailsArray().controls.forEach((control: AbstractControl) => {
        const pagesControl = control.get('pages');
        if (pagesControl) {
          pagesControl.setValidators([
            Validators.required,
            this.pageLimitValidator(this.totalPages),
          ]);
          pagesControl.updateValueAndValidity();
        }
      });
    }

    if (changes['uploadFileData'] && this.uploadFileData?.totalPages) {
      this.totalPages = this.uploadFileData.totalPages;

      const pagesControl = this.esignDetails.get('pages');
      if (pagesControl) {
        pagesControl.setValidators([
          Validators.required,
          this.pageLimitValidator(this.totalPages),
        ]);
        pagesControl.updateValueAndValidity();
      }
    }
  }

  ngOnDestroy() {
    if (this.signatureStateSubscription) {
      this.signatureStateSubscription.unsubscribe();
    }
    this.storageService.setDraftData(null);
    this.signatureStateService.clearAllStates();
  }
  //----------------------------------------------Get Addinional Fields details ------------------------------------//

  getEsignAddionalFields() {
    if (this.contractType) {
      this.signMethod = [{ name: 'Aadhaar', code: 'AADHAAR', inactive: false }];
      this.aadhaarVerificationMethod = [
        { name: 'OTP', code: 'OTP', inactive: false },
      ];
      const value = this.storageService.getContractNumber();

      this.catUploadService.getAddionalFieldDetails(value).subscribe((res) => {
        this.formData = res['content'];

        const filteredData = this.formData.filter((item: any) => {
          const key = Object.keys(item)[0];
          const module = item[key].module;
          return module === 'esign' || module === 'esign.signatory';
        });
        this.formData = filteredData;
        this.createForm();
        if (this.savedData?.addPartyDetailsForm.length > 0) {
          this.savedData?.addPartyDetailsForm?.forEach((element) => {
            this.partyDetailsArray().push(this.initPartyDetails('PARTY'));
          });
        } else {
          this.partyDetailsArray().push(this.initPartyDetails('PARTY'));
          this.partyDetailsArray().push(this.initPartyDetails('PARTY'));
        }
      });
    } else {
      if (this.savedData?.addPartyDetailsForm.length > 0) {
        this.savedData?.addPartyDetailsForm?.forEach((element) => {
          this.partyDetailsArray().push(this.initPartyDetails('PARTY'));
        });
      } else {
        this.partyDetailsArray().push(this.initPartyDetails('PARTY'));
      }
    }
  }

  ngAfterViewInit() {
    if (this.contractType) {
      this.showOrderIndex(false);
    }
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
    this.rebuildSignatoryPositions();
  }
  createForm() {
    this.formData.forEach((item: any) => {
      const key = Object.keys(item)[0]; // Field key
      const field = item[key]; // Field details
      if (field.module === 'esign') {
        const control = field.mandatory
          ? new FormControl('', Validators.required)
          : new FormControl('');
        this.dynamicForm.addControl(key, control);
        this.sameEsignValues = true;
      }
    });
  }

  createEsignForm(index?) {
    var savedData =
      this.savedData?.addPartyDetailsForm?.[index]?.['additional_fields'];
    const addEsignFields = this.formBuilder.group({}); // Create a FormGroup for dynamic fields

    this.formData.forEach((item: any) => {
      const key = Object.keys(item)[0];
      const field = item[key];
      const value = savedData?.[key] || '';
      if (!this.selectedOptions[index]) {
        this.selectedOptions[index] = {};
      }
      if (value) this.selectedOptions[index][key] = value;
      if (field.module === 'esign.signatory') {
        const control = field.mandatory
          ? new FormControl(value, Validators.required)
          : new FormControl(value);

        addEsignFields.addControl(key, control);
      }
    });

    return addEsignFields;
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  getOptionKey(option: any): string {
    return option ? Object.keys(option)[0] : '';
  }

  getOptionValue(option: any): string {
    const key = this.getOptionKey(option);
    return key && option[key] ? option[key] : '';
  }

  getFilteredOptions(options: any[], key: string, index: number): any[] {
    const selectedValues: any[] = [];
    const uniqueOnceKeys = ['CR', 'DT'];

    if (key === 'CONTRACT_RELATION') {
      const addPartyDetailsForm = this.esignDetails.get(
        'addPartyDetailsForm',
      ) as FormArray;

      if (addPartyDetailsForm && addPartyDetailsForm.controls) {
        addPartyDetailsForm.controls.forEach((element, i) => {
          if (i !== index) {
            const additionalFields = element.get('additional_fields');
            const value = additionalFields.get(key)?.value;
            if (value) {
              selectedValues.push(value);
            }
          }
        });
      }
    }
    return options.filter((option) => {
      const optionKey = this.getOptionKey(option);
      if (uniqueOnceKeys.includes(optionKey)) {
        return !selectedValues.includes(optionKey);
      }
      return true;
    });
  }

  onSelectionInput(index: number, fieldKey: string, value: string) {
    if (!this.selectedOptions[index]) {
      this.selectedOptions[index] = {};
    }

    this.selectedOptions[index][fieldKey] = value;
  }

  handleOTCondition(index: number, fieldKey: string, value: string) {
    const partyFormGroup: any = (
      this.esignDetails.get('addPartyDetailsForm') as FormArray
    ).at(index) as FormGroup;

    if (value === 'OT') {
      partyFormGroup
        .get('additional_fields')
        .addControl(
          'official_document_name',
          new FormControl('', [Validators.required]),
        );
      const otherValue = {
        official_document_name: {
          label: 'Official Document Name',
          mandatory: true,
          data_type: 'OT',
          module: 'esign.signatory',
        },
      };
      if (!this.formData.some((item) => item['official_document_name'])) {
        this.formData.push(otherValue);
      }
    } else {
      if (
        partyFormGroup.get('additional_fields').get('official_document_name') &&
        fieldKey == 'Official_Document_Type'
      ) {
        partyFormGroup
          .get('additional_fields')
          .removeControl('official_document_name');
      }
    }
  }

  onSelectionDropDown(index: number, fieldKey: string, value: string) {
    this.selectedValue = value;
    this.handleOTCondition(index, fieldKey, value);
    if (!this.selectedOptions[index]) {
      this.selectedOptions[index] = {};
    }
    this.selectedOptions[index][fieldKey] = value;
  }

  validatePayeeName() {
  const control = this.esignDetails.get('payeeName');
  const value = control?.value || '';

  const hasLeadingOrTrailingSpace =
    value.startsWith(' ') || value.endsWith(' ');

  if (hasLeadingOrTrailingSpace) {
    control?.setErrors({
      ...control.errors,
      spaceNotAllowed: true
    });
  } else if (control?.hasError('spaceNotAllowed')) {
    const errors = { ...control.errors };
    delete errors['spaceNotAllowed'];

    control.setErrors(Object.keys(errors).length ? errors : null);
  }
}
  isSelectedOT(index: number): boolean {
    if (this.selectedOptions && this.selectedOptions[index]) {
      return Object.values(this.selectedOptions[index]).includes('OT');
    }
    return false;
  }

  validateOptions(options: Option[]): string {
    const panSet = new Set<string>();
    for (const item of options) {
      if (panSet.has(item.PAN)) {
        // return `Duplicate PAN found: ${item.PAN}`;
      }
      panSet.add(item.PAN);
    }

    return null;
  }

  maxLengthValidator() {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      if (value && value.length > 100) {
        return { maxLength: true }; // Return an error if length exceeds 100
      }

      return null;
    };
  }

  // Build Changes

  //-------------------------------------------------------------------------------------------------//
  initPartyDetails(value) {
    this.submitted = false;
    if (value == 'PARTY') {
      this.order_count =
        this.esignDetails.controls['addPartyDetailsForm'].value.length + 1;
    } else if (value === 'WITNESS') {
      this.order_count = 0;
    }

    const index = this.order_count - 1;

    const addEsignFields = this.createEsignForm(index);

    const contactNumberValidators = [
      Validators.pattern(this.phonePattern),
      Validators.maxLength(10),
      Validators.minLength(10),
    ];

    // Get saved values
    const savedParty = this.savedData?.addPartyDetailsForm?.[index];
    const savedSignaturePlacementType =
      savedParty?.['signature_placement_type'] || '';
    const savedSignPosition = savedParty?.['sign_position'] || '';
    const savedPositionDetails = savedParty?.['position_details'] || {};

    // Determine initial values for the two dropdowns
    let signaturePlacementType = savedSignaturePlacementType || '';
    let signatorySignPosition = '';

    // If signature_placement_type is DRAG_DROP, sign_position should be empty
    // If signature_placement_type is NORMAL, sign_position contains the actual position
    if (signaturePlacementType === 'NORMAL' && savedSignPosition) {
      signatorySignPosition = savedSignPosition;
    }

    return this.formBuilder.group({
      name: new FormControl(savedParty?.['name']?.trim() || '', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z\s]*$/),
        Validators.maxLength(50),
        this.noOnlySpacesValidator,
      ]),
      email: new FormControl(savedParty?.['email'] || '', [
        (control: AbstractControl) => {
          if (!control.value || control.value.trim() === '') {
            return null;
          }
          const emailPattern =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          return emailPattern.test(control.value) ? null : { email: true };
        },
      ]),
      contact_number: new FormControl(
        savedParty?.['contact_number'] || '',
        contactNumberValidators,
      ),
      method: new FormControl(
        this.isAbclMidMarket ? 'AADHAAR' : (savedParty?.['method'] || ''), 
        [Validators.required]
      ),
      position_details: new FormControl(savedPositionDetails),
      pages: new FormControl(savedParty?.['pages'] || 'ALL', [
        Validators.required,
        this.pageLimitValidator(this.totalPages),
      ]),
      signature_placement_type: [signaturePlacementType, [Validators.required]],
      sign_position: [signatorySignPosition, []],
      signatory_sequence: new FormControl(
        savedParty?.['signatory_sequence'] || this.order_count,
      ),
      send_document: new FormControl(
        savedParty?.['send_document'] || this.signedDocumentYes,
      ),
      send_notification: new FormControl(
        savedParty?.['send_notification'] || this.sendNotificationYes,
      ),
      remark: [savedParty?.['remark'] || ''],
      reminder: [savedParty?.['reminder'] || 1],
      schedule_timestamp: [savedParty?.['schedule_timestamp'] || null],
      server_side_siganture: new FormControl(
        savedParty?.['server_side_siganture'] || this.serverSideNo,
      ),
      estamp_sign: new FormControl(
        this.stampSignToggle && this.documentToBeStamped
          ? (savedParty?.['estamp_sign'] ?? this.estampSignYes)
          : false,
      ),
      additional_fields: addEsignFields,
      aadhaar_digits: new FormControl(savedParty?.['aadhaar_digits'] || ''),
      sign_mode: new FormControl(savedParty?.['sign_mode'] || ''),
      is_authorised: new FormControl(savedParty?.['is_authorised'] ?? false),
      authorised_for: new FormControl(savedParty?.['authorised_for'] || ''),
      isSignaturePlacementDone: [
        savedParty?.['isSignaturePlacementDone'] || false,
      ],
    });
  }

  markSignaturePlacementDone(content: any, index: number) {
    const signatory = this.partyDetailsArray().at(index).value;

    if (!signatory.name || signatory.name.trim() === '') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Signer Details',
        detail: `Please fill Party details for signatory ${index + 1}`,
      });
      return;
    }

    if (
      signatory.sign_position === 'NORMAL' &&
      Object.keys(signatory.position_details).length === 0
    ) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Position Details',
        detail: `Please select position to sign for signatory ${index + 1}`,
      });
      return;
    }

    // Check if signatures are already placed for this signatory
    const hasSignatures = this.signatureStateService.hasSignatures(index);
    const isPlacementDone = this.partyDetailsArray()
      .at(index)
      .get('isSignaturePlacementDone')?.value;

    if (hasSignatures) {
      // If signatures exist, always allow reassignment - directly open assignment dialog
      // Reset the placement status to allow reassignment
      this.partyDetailsArray()
        .at(index)
        .get('isSignaturePlacementDone')
        .setValue(false);
      // Proceed with assignment
      this.assignSignatures(content);
      this.currentSignatoryIndex = index;
    } else {
      // If no signatures, proceed with assignment
      this.assignSignatures(content);
      this.currentSignatoryIndex = index;
    }
  }
  //--------------------------------------------------------------------------------------------------------------------//

  /**
   * In the Contract Edit (template) flow there is no uploaded PDF, so the
   * shared component never receives a totalPages value. This fetches the
   * template's rendered PDF, counts its pages with pdf-lib and applies the
   * page-limit validation to every signatory's "pages" control - mirroring
   * the behaviour of the upload flow.
   */
  private detectTemplatePageCount(): void {
    const pdfData = this.esignData?.pdfData;
    if (!pdfData) {
      return;
    }

    this.orderService.getEditTemplatePDFDocument(pdfData).subscribe({
      next: async (resp: any) => {
        try {
          const base64 = resp?.content?.document_url;
          if (!base64) {
            return;
          }

          const byteArray = Uint8Array.from(atob(base64), (char) =>
            char.charCodeAt(0),
          );
          const pdfDoc = await PDFDocument.load(byteArray);
          this.totalPages = pdfDoc.getPageCount();

          this.applyPageLimitValidators();
          this.cdr.detectChanges();
        } catch (error) {
          console.error('Template PDF page-count detection failed:', error);
        }
      },
      error: (error) => {
        console.error('Failed to fetch template PDF for page count:', error);
      },
    });
  }

  private applyPageLimitValidators(): void {
    const partyArray = this.esignDetails.get(
      'addPartyDetailsForm',
    ) as FormArray;
    const witnessArray = this.esignDetails.get(
      'addWitnessDetailsForm',
    ) as FormArray;

    [...(partyArray?.controls ?? []), ...(witnessArray?.controls ?? [])].forEach(
      (control) => {
        const pagesControl = control.get('pages');
        if (pagesControl) {
          pagesControl.setValidators([
            Validators.required,
            this.pageLimitValidator(this.totalPages),
          ]);
          pagesControl.updateValueAndValidity();
        }
      },
    );
  }

  pageLimitValidator(totalPages: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim();
      if (!value) return null;

      if (value.toUpperCase() === 'ALL') {
        return null;
      }

      // In CAT Compose the rendered-template page count loads asynchronously.
      // Allow page entries until it is available; the fetched count is then
      // applied to the controls by applyPageLimitValidators(). Keep the other
      // services' existing validation behavior unchanged.
      if (this.isCatComposeRoute() && this.totalPages <= 0) {
        return null;
      }

      const invalidPages: number[] = [];

      const parts = value.split(',');
      for (let part of parts) {
        part = part.trim();
        if (part.includes('-')) {
          const [startStr, endStr] = part.split('-');
          const start = parseInt(startStr, 10);
          const end = parseInt(endStr, 10);
          if (
            isNaN(start) ||
            isNaN(end) ||
            start > end ||
            start < 1 ||
            end > this.totalPages
          ) {
            invalidPages.push(
              ...Array.from({ length: end - start + 1 }, (_, i) => start + i),
            );
          }
        } else {
          const num = parseInt(part, 10);
          if (isNaN(num) || num < 1 || num > this.totalPages) {
            invalidPages.push(num);
          }
        }
      }

      if (invalidPages.length > 0) {
        return { pageLimitExceeded: { invalidPages } };
      }

      return null;
    };
  }

  private isCatComposeRoute(): boolean {
    const path = this._location.path().split('?')[0].replace(/\/+$/, '');
    return path === '/doqfy/cat-compose/form';
  }

  getESignDefaultDetails() {
    this.showESignSettings = this.featureFlagService.isOrgFeatureEnabled('esignDefault');
  }

  getDefaultFieldData(account_id) {
    this.userDashboardService
      .getDefaultFieldData(account_id)
      .subscribe((res: any) => {
        this.esign_default_fields =
          res['content']['esign_default_fields'] || [];

        // let sign_position;
        // if (this.esign_default_fields.sign_position === 'DRAG_DROP') {
        //   sign_position = 'DRAG_DROP'
        //   this.showPredefined[0] = false;
        // }
        // else {
        //   sign_position = 'NORMAL'
        //   this.showPredefined[0] = true;
        // }

        const formArray = this.esignDetails.get(
          'addPartyDetailsForm',
        ) as FormArray;

        // 2. Check if formArray has items AND if our new array has at least one default item
        if (
          formArray.controls.length > 0 &&
          this.esign_default_fields.length > 0
        ) {
          const firstControl = formArray.at(0);
          const defaultData = this.esign_default_fields[0];

          // --- THE DRAFT GUARD ---
          // We only apply defaults if the fields are currently empty.
          const currentName = firstControl.get('name')?.value;
          const currentEmail = firstControl.get('email')?.value;
          firstControl.patchValue(
            {
              name:
                !currentName || currentName === ''
                  ? defaultData.party_name
                  : currentName,
              email:
                !currentEmail || currentEmail === ''
                  ? defaultData.party_email
                  : currentEmail,
              contact_number: !firstControl.get('contact_number')?.value
                ? defaultData.contact_number
                : firstControl.get('contact_number')?.value,
              method: !firstControl.get('method')?.value
                ? defaultData.sign_method
                : firstControl.get('method')?.value,
              sign_mode: !firstControl.get('sign_mode')?.value
                ? defaultData.sign_mode
                : firstControl.get('sign_mode')?.value,
              aadhaar_digits: !firstControl.get('aadhaar_digits')?.value
                ? defaultData.aadhaar_four_digit
                : firstControl.get('aadhaar_digits')?.value,
            },
            { emitEvent: false },
          );

          this.selectedSignMethod = firstControl.get('method')?.value;
          this.selectedAadhaarVerificationMethod =
            firstControl.get('sign_mode')?.value;
        }
      });
  }
  // ---------------------Check for duplicates -------------------------------//

  hasDuplicates(array, fieldName) {
    const values = array.map((item) => item[fieldName]);
    return new Set(values).size !== values.length;
  }

  /*------------------------------- add Party Details --------------------------------------------*/

  removePartyDetails(index: number) {
    const removedSignatoryAbsoluteId =
      this.partyDetailsArray().at(index).get('signatory_sequence')?.value ??
      index + 1;
    const removedSlotId = this.partyDetailsArray()
      .at(index)
      .get('signatory_sequence')?.value;

    const totalSignatoriesBeforeRemoval = this.partyDetailsArray().length;

    const removedAbsoluteIndex = removedSlotId - 1;
    this.signatureStateService.clearSignatureState(removedAbsoluteIndex);
    this.signatureStateService.reindexStates(
      removedAbsoluteIndex,
      totalSignatoriesBeforeRemoval - 1,
    );

    this.partyDetailsArray().removeAt(index);

    const newTotalSignatories = this.partyDetailsArray().length;
    Object.keys(this.signPlacementDetails).forEach((pageNumber) => {
      const pageArray = this.signPlacementDetails[pageNumber];
      if (pageArray && Array.isArray(pageArray)) {
        // Find and null-out only the removed signatory's slot by id
        const slotIndex = pageArray.findIndex(
          (s: any) => s && s.id === removedSlotId,
        );
        if (slotIndex >= 0) {
          pageArray.splice(slotIndex, 1);
        }

        const hasAnySignature = pageArray.some(
          (signer: any) =>
            signer && signer.signBoxList && signer.signBoxList.length > 0,
        );
        if (!hasAnySignature && newTotalSignatories === 0) {
          delete this.signPlacementDetails[pageNumber];
        }
      }
    });

    if (index === 0) {
      this.showSignaotryDetails = false;
    }

    setTimeout(() => {
      for (let i = 0; i < this.partyDetailsArray().length; i++) {
        this.getPlacementType(i);
      }
      this.updatePredefinedOptionState();
      this.cdr?.detectChanges();
    }, 50);

    console.log('Dekhiba removePartyDetails', this.signPlacementDetails);
  }
  partyDetailsArray(): FormArray {
    return this.esignDetails.get('addPartyDetailsForm') as FormArray;
  }

  onEmailChange(event: any) {}

  addNewPartyDetails() {

    if (this.isDefaultSignatureSelected && this.partyDetailsArray().length >= 10) {
      this.messageService.add({
        severity: 'info', 
        summary: 'Maximum Limit Reached',
        detail: 'You can only add a maximum of 10 signatories when Default signature is selected.',
      });
      return;
    }

    const checkIndex = this.partyDetailsArray().length - 1;
    const partyDetails = this.partyDetailsArray().value;

    // ── FIX: Separate validation for DRAG_DROP and NORMAL ──
    if (this.partyDetailsArray().length > 0) {
      const currentParty = this.partyDetailsArray().at(checkIndex);
      const placementType = currentParty.get('signature_placement_type')?.value;

      if (placementType === 'DRAG_DROP') {
        // For DRAG_DROP: check signature count (existing logic)
        if (this.getSignatureCount(checkIndex) === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Party Details',
            detail: 'Assign signature before adding new signatory',
          });
          return;
        }
      } else if (placementType === 'NORMAL') {
        // For NORMAL (Pre-Defined): check sign_position is selected
        const signPosition = currentParty.get('sign_position')?.value;
        if (!signPosition || signPosition.trim() === '') {
          this.messageService.add({
            severity: 'warn',
            summary: 'Party Details',
            detail: 'Please select a sign position before adding new signatory',
          });
          return;
        }
      }
    }

    // Check if both email and contact number are empty for current party
    if (this.partyDetailsArray().length > 0) {
      const currentParty = this.partyDetailsArray().at(checkIndex);
      const email = currentParty.get('email')?.value;
      const contactNumber = currentParty.get('contact_number')?.value;

      if (
        (!email || email.trim() === '') &&
        (!contactNumber || contactNumber.trim() === '')
      ) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Party Details',
          detail: 'Email or mobile number required',
        });
        return;
      }
    }

    // Duplicate email check removed — same email/contact across signatories is allowed

    const esignValue = this.partyDetailsArray().value[checkIndex];

    if (!this.esignDetails.controls['addPartyDetailsForm'].valid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Party Details',
        detail: 'Please fill Party details before adding New',
      });
      return;
    }

    // ── FIX: Updated final check also using placement type ──
    const currentPlacementType = this.partyDetailsArray().at(checkIndex).get('signature_placement_type')?.value;
    if (currentPlacementType === 'NORMAL') {
      const signPosition = this.partyDetailsArray().at(checkIndex).get('sign_position')?.value;
      if (!signPosition || signPosition.trim() === '') {
        this.messageService.add({
          severity: 'warn',
          summary: 'Party Details',
          detail: 'Please select a sign position before adding new signatory',
        });
        return;
      }
    } else {
      this.showSignaotryDetails = true;
    }

    this.partyDetailsArray().push(this.initPartyDetails('PARTY'));
    const newIndex = this.partyDetailsArray().length - 1;
    this.rebuildSignatoryPositions();

    if (this.isDefaultSignatureSelected) {
      const newControl = this.partyDetailsArray().at(newIndex);
      newControl.get('signature_placement_type')?.setValue('DEFAULT');
      newControl.get('sign_position')?.setValue('DEFAULT');
    }

    if (
      this.isDefault && this.esign_default_fields &&
      newIndex < this.esign_default_fields.length
    ) {
      const newControl = this.partyDetailsArray().at(newIndex);
      const defaultData = this.esign_default_fields[newIndex];
      let methodToPatch = defaultData.sign_method || '';
      if (this.isAbclMidMarket) {
        methodToPatch = 'AADHAAR';
      }
      newControl.patchValue(
        {
          name: defaultData.party_name || '',
          email: defaultData.party_email || '',
          contact_number: defaultData.contact_number || '',
          method: methodToPatch,
          sign_mode: defaultData.sign_mode || '',
          aadhaar_digits: defaultData.aadhaar_four_digit || '',
        },
        { emitEvent: false },
      );
    }

    for (let i = 0; i < this.partyDetailsArray().length; i++) {
      if (i === newIndex) {
        this.getPlacementType(i);
      } else {
        this.refreshDisplayStateOnly(i);
      }
    }

    const currentPayVal = this.esignDetails.controls['paymentMethod'].value;
    this.paymentMethod(currentPayVal);

  }
  
  private emailOrContactRequiredValidator(
    control: AbstractControl,
  ): ValidationErrors | null {
    const email = control.get('email');
    const contactNumber = control.get('contact_number');

    const hasEmail = email && email.value && email.value.trim() !== '';
    const hasContact =
      contactNumber && contactNumber.value && contactNumber.value.trim() !== '';

    if (!hasEmail && !hasContact) {
      return { emailOrContactRequired: true };
    }

    return null;
  }
  //-------------------------------------------------Increse and decrese of Order------------------------------------//
  noOnlySpacesValidator(control: FormControl) {
    if (control.value && control.value.trim().length === 0) {
      return { noOnlySpaces: true };
    }
    return null; // Validation passes
  }

  // Getter for easy access to the name FormControl

  orderChange(index: number, value: string) {}

  /**
   * Keeps the DOM node bound to its FormGroup while the order changes, so the
   * browser moves the existing row instead of rebuilding it. This is what makes
   * the reorder animation possible.
   */
  trackByControl = (_index: number, control: AbstractControl) => control;

  increaseOrder(index: number, value: string) {
    this.animateReorder(value, () => this.applyIncreaseOrder(index, value));
  }

  decreseOrder(index: number, value: string) {
    this.animateReorder(value, () => this.applyDecreaseOrder(index, value));
  }

  private signatoryFormArray(value: string): FormArray | undefined {
    if (value === 'PARTY') {
      return this.esignDetails.controls['addPartyDetailsForm'] as FormArray;
    }
    if (value === 'WITNESS') {
      return this.esignDetails.controls['addWitnessDetailsForm'] as FormArray;
    }
    return undefined;
  }

  private reorderRowElements(value: string): HTMLElement[] {
    const rows = value === 'WITNESS' ? this.witnessRows : this.signatoryRows;
    return rows ? rows.map((row) => row.nativeElement) : [];
  }


  private animateReorder(value: string, applyChange: () => void): void {
    const formArray = this.signatoryFormArray(value);
    const rowsBefore = this.reorderRowElements(value);

    if (!formArray || !rowsBefore.length || !this.canAnimateReorder(rowsBefore[0])) {
      applyChange();
      return;
    }

    const controlsBefore = formArray.controls.slice();
    const firstTops = new Map<AbstractControl, number>();
    rowsBefore.forEach((element, rowIndex) => {
      const control = controlsBefore[rowIndex];
      if (control) {
        firstTops.set(control, element.getBoundingClientRect().top);
      }
    });

    const scrollState = this.captureScrollPositions(rowsBefore[0]);

    applyChange();
    this.cdr.detectChanges();
    this.restoreScrollPositions(scrollState);

    const controlsAfter = formArray.controls;
    const rowsAfter = this.reorderRowElements(value);

    // Cancel in-flight animations first so the measurements below are real
    // layout positions and not transformed ones, then measure in one pass.
    rowsAfter.forEach((element) => this.reorderAnimations.get(element)?.cancel());
    const deltas = rowsAfter.map((element, rowIndex) => {
      const control = controlsAfter[rowIndex];
      const firstTop = control ? firstTops.get(control) : undefined;
      return firstTop === undefined
        ? 0
        : firstTop - element.getBoundingClientRect().top;
    });

    rowsAfter.forEach((element, rowIndex) => {
      const delta = deltas[rowIndex];
      if (Math.abs(delta) < 1) {
        return;
      }

      element.classList.add('is-reordering');
      const animation = element.animate(
        [
          { transform: `translateY(${delta}px)` },
          { transform: 'translateY(0)' },
        ],
        {
          duration: this.REORDER_ANIMATION_MS,
          easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
        },
      );
      this.reorderAnimations.set(element, animation);

      const cleanup = () => {
        if (this.reorderAnimations.get(element) !== animation) {
          return;
        }
        this.reorderAnimations.delete(element);
        element.classList.remove('is-reordering');
      };
      animation.onfinish = cleanup;
      animation.oncancel = cleanup;
    });
  }

  private canAnimateReorder(element: HTMLElement): boolean {
    if (typeof element?.animate !== 'function') {
      return false;
    }
    return !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  }

  private captureScrollPositions(
    element: HTMLElement,
  ): Array<{ node: HTMLElement | null; top: number; left: number }> {
    const positions: Array<{
      node: HTMLElement | null;
      top: number;
      left: number;
    }> = [];

    let parent = element?.parentElement ?? null;
    while (parent) {
      const { overflowY } = window.getComputedStyle(parent);
      if (
        /(auto|scroll|overlay)/.test(overflowY) &&
        parent.scrollHeight > parent.clientHeight
      ) {
        positions.push({
          node: parent,
          top: parent.scrollTop,
          left: parent.scrollLeft,
        });
      }
      parent = parent.parentElement;
    }

    // `node: null` represents the window / document scroller.
    positions.push({ node: null, top: window.scrollY, left: window.scrollX });
    return positions;
  }

  private restoreScrollPositions(
    positions: Array<{ node: HTMLElement | null; top: number; left: number }>,
  ): void {
    positions.forEach(({ node, top, left }) => {
      // `behavior: instant` bypasses the global `scroll-behavior: smooth`.
      const options = { top, left, behavior: 'instant' } as ScrollToOptions;

      if (!node) {
        if (window.scrollY !== top || window.scrollX !== left) {
          window.scrollTo(options);
        }
        return;
      }

      if (node.scrollTop === top && node.scrollLeft === left) {
        return;
      }

      if (typeof node.scrollTo === 'function') {
        node.scrollTo(options);
      } else {
        node.scrollTop = top;
        node.scrollLeft = left;
      }
    });
  }

  private applyIncreaseOrder(index: number, value: string) {
    let formArray: FormArray;
    if (value === 'PARTY') {
      formArray = this.esignDetails.controls[
        'addPartyDetailsForm'
      ] as FormArray;
    } else if (value === 'WITNESS') {
      formArray = this.esignDetails.controls[
        'addWitnessDetailsForm'
      ] as FormArray;
    }

    if (formArray && index < formArray.length - 1) {
      const currentOrder = formArray.at(index);
      const nextOrder = formArray.at(index + 1);

      formArray.setControl(index, nextOrder);
      formArray.setControl(index + 1, currentOrder);

      // Swap signature states and signPlacementDetails to match new positions
      if (value === 'PARTY') {
        this.swapSignatureStates(index, index + 1);
      }
    }

    formArray.controls.forEach((control, controlIndex) => {
      if (value === 'PARTY') {
        this.refreshDisplayStateOnly(controlIndex); // ← was: getPlacementType
      } else if (value === 'WITNESS') {
        this.getPlacementTypeWitness(controlIndex);
      }
    });

    this.setOrderNumber(value);
  }
  getSignMethodControl(index: number): FormControl {
    return this.partyDetailsArray().at(index).get('method') as FormControl;
  }

  onSignMethodChange(event: any, index: number) {
    const formGroup = this.partyDetailsArray().at(index);
    const selectedMethod = event.value;

    if (selectedMethod !== 'AADHAAR') {
      formGroup.get('aadhaar_digits')?.reset();
      formGroup.get('sign_mode')?.reset();
    }

    if (selectedMethod !== 'ELECTRONIC' || selectedMethod === 'CLOUD_SIGN') {
      formGroup.get('server_side_siganture')?.setValue(this.serverSideNo);
    }
  }
  isElectronicMethod(index: number): boolean {
    const formGroup = this.partyDetailsArray().at(index);
    return formGroup.get('method')?.value === 'ELECTRONIC';
  }
  onAadhaarVerficationMethodChange(event: any) {
    this.selectedAadhaarVerificationMethod = event.value;
  }

  private applyDecreaseOrder(index: number, value: string) {
    let formArray: FormArray;
    if (value === 'PARTY') {
      formArray = this.esignDetails.controls[
        'addPartyDetailsForm'
      ] as FormArray;
    } else if (value === 'WITNESS') {
      formArray = this.esignDetails.controls[
        'addWitnessDetailsForm'
      ] as FormArray;
    }

    if (formArray && index > 0) {
      const currentOrder = formArray.at(index);
      const previousOrder = formArray.at(index - 1);

      formArray.setControl(index, previousOrder);
      formArray.setControl(index - 1, currentOrder);

      // Swap signature states and signPlacementDetails to match new positions
      if (value === 'PARTY') {
        this.swapSignatureStates(index, index - 1);
      }
    }

    formArray.controls.forEach((control, controlIndex) => {
      if (value === 'PARTY') {
        this.refreshDisplayStateOnly(controlIndex);
      } else if (value === 'WITNESS') {
        this.getPlacementTypeWitness(controlIndex);
      }
    });

    this.setOrderNumber(value);
  }

  setOrderNumber(value: string) {
    let formArray;
    if (value === 'PARTY') {
      formArray = this.esignDetails.controls[
        'addPartyDetailsForm'
      ] as FormArray;
    } else if (value === 'WITNESS') {
      formArray = this.esignDetails.controls[
        'addWitnessDetailsForm'
      ] as FormArray;
    }

    if (formArray) {
      formArray.controls.forEach((control, index) => {
        control.get('signatory_sequence').patchValue(index + 1);
      });
    }
  }

  hasDuplicatesInArray(array) {
    return new Set(array).size !== array.length;
  }

  // Toggle handler
  onDraftToggle() {
    const currentPayment = this.esignDetails.get('paymentMethod')?.value;

    if (
      this.showPlaceOrder ||
      currentPayment === this.paymentbyRazorpay ||
      currentPayment === 'HDFC_GATEWAY'
    ) {
      return;
    }

    this.isDraft = !this.isDraft;
    this.draftChange.emit(this.isDraft);

    // If switching TO draft mode, save and redirect
    if (this.isDraft) {
      setTimeout(() => {
        this.sendSignerDetails();
      }, 100);
    }
    // console.log('Draft mode:', this.isDraft ? 'ON' : 'OFF');
  }

  parentIsDraftFalse() {
    this.isDraft = false; // Force false for Place Order
    this.draftChange.emit(false);
  }

  private readonly STANDARD_PAGE_WIDTH = 595;
  private readonly STANDARD_PAGE_HEIGHT = 842;

  // One shared calculation for every flow (see signature-position.util).
  private getSignatureRect(
    method: 'ELECTRONIC' | 'AADHAAR' | 'DSC',
    signPosition: string,
    pageWidth: number,
    pageHeight: number
  ): { x1: number; x2: number; y1: number; y2: number } {
    return getStandardSignatureRect(method, signPosition, pageWidth, pageHeight);
  }

  sendSignerDetails() {
    if (this.showPlaceOrder) {
      return;
    }
    const partyDetails = this.partyDetailsArray().value;
    this.partyDetailsArray().controls.forEach((control) => {
      const nameControl = control.get('name');
      if (nameControl && nameControl.value) {
        nameControl.setValue(nameControl.value.trim());
      }
    });

    if (this.contractType) {
      const contractFields = this.validateOptions(this.selectedOptions);
      if (contractFields) {
        this.messageService.add({
          severity: 'warn',
          detail: `${contractFields}`,
        });
        return;
      }
    }

    // Duplicate email check removed — same email/contact across signatories is allowed

    if (this.displayMailSchedule) {
      const partyDetails = this.partyDetailsArray().value;
      partyDetails.forEach((res, index) => {
        const date = res.schedule_timestamp;
        const selectedDateTime = new Date(date);
        const minDateTime = new Date();
        if (selectedDateTime < minDateTime) {
          this.scheduleError[index] = true;
          this.selectedDateValue[index] = moment(new Date(minDateTime)).format('lll');
        } else {
          this.scheduleError[index] = false;
        }
      });
    }

    if (this.aadhaar_validation && this.isDocumentType === '003') {
      const partyDetails = this.partyDetailsArray().value;

      for (let index = 0; index < partyDetails.length; index++) {
        const res = partyDetails[index];

        if (this.aadhaar_validation && res.method === 'AADHAAR') {
          if (res.aadhaar_digits.length < 4) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Aadhaar digits',
              detail: 'Please enter last 4 digits of Aadhaar',
            });
            return;
          }
        }
      }
    }

    if (this.isEsigned) {
      if (!this.contractType) {
        const partyDetails = this.partyDetailsArray().value;
        const witnessDetails = this.witnessDetailsArray().value;
        const allSigners = [...partyDetails, ...witnessDetails];

        for (let index = 0; index < allSigners.length; index++) {
          const signer = allSigners[index];

          if (
            signer.method === 'AADHAAR' &&
            this.showSignMode &&
            (!signer.sign_mode || signer.sign_mode.trim() === '')
          ) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Sign Mode Required',
              detail: 'Please select Sign Mode',
            });
            return;
          }
        }
      }
    }

    const isError = this.scheduleError.some((error) => error === true);
    if (isError) {
      const timeData = moment(new Date()).format('lll');
      this.messageService.add({
        severity: 'warn',
        summary: 'Schedule Time Issue',
        detail: `Schedule Time must be later then ${timeData} `,
      });
      return;
    }

    this.submitted = true;
    const paymentBySignerValue = this.esignDetails.controls.paymentbySigner.value;
   const isWalletSelected = this.isDraft 
      ? false 
      : (this.esignDetails.value.paymentMethod === this.paymentbyWallet);

    const isPaymentRequired = this.isDraft 
      ? false 
      : this.showPayment;

    if (!isPaymentRequired && !isWalletSelected) {
      this.esignDetails.controls.paymentbySigner.setValue(false);
      this.esignDetails.controls.paymentMethod.setValue(this.payLater);
      this.storageService.getSignerValue.next(false); 
    }
    let data = {
      document: '',
      signatoryDetails: [],
      placeOrder: true,
      paymentbySigner: this.esignDetails.value.paymentbySigner,
      paymentMethod: this.esignDetails.value.paymentMethod,
      payeeName: this.esignDetails.value.payeeName,
      payeeEmail: this.esignDetails.value.payeeEmail,
      payeeMobileNumber: this.esignDetails.value.payeeMobileNumber,
      payNowOrLater: this.esignDetails.value.payNowOrLater,
    };

    if (this.isEsigned) {
      let signDetails = [];
      if (this.esignDetails.invalid) {
        return;
      }
      // Never let a Pre-Defined signature land on top of a drag & drop one.
      if (!this.isDefaultSignatureSelected) {
        const partyCount = this.partyDetailsArray().length;
        for (let i = 0; i < partyCount; i++) {
          if (this.rejectDragDropClash(i)) {
            this.rebuildSignatoryPositions();
            return;
          }
        }
      }
      const partyDetails = this.partyDetailsArray().value;
      const witnessDetails = this.witnessDetailsArray().value;

      signDetails.push(...partyDetails, ...witnessDetails);

      for (let index = 0; index < signDetails.length; index++) {
        const sign = signDetails[index];

        // ── FIX: Capture placement type BEFORE deleting it ──
        const placementType = sign.signature_placement_type;

        if (this.isDefaultSignatureSelected) {
          if (sign.method === 'AADHAAR' || sign.method === 'DSC') {
            sign.sign_position = this.defaultAadhaarPositions[index];
          } else if (sign.method === 'ELECTRONIC') {
            sign.sign_position = this.defaultElectronicPositions[index];
          } else {
            sign.sign_position = this.defaultElectronicPositions[index];
          }
        } else {
          if (placementType === 'DRAG_DROP') {
            sign.sign_position = 'DRAG_DROP';
          } else if (placementType === 'NORMAL') {
            // sign_position holds the selected position code
          } else {
            sign.sign_position = placementType;
          }
        }

        // Remove the temporary field
        delete sign.signature_placement_type;

        // Authorised signature is party-only (witnesses aren't authorized 
        // signatories), required when this signatory opted in.
        if (
          index < partyDetails.length &&
          sign.is_authorised &&
          (!sign.authorised_for || !sign.authorised_for.trim())
        ) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Authorised For Missing',
            detail: `Please enter the Authorised For value for signatory ${index + 1}`,
          });
          return;
        }

        // ── FIX: Validate NORMAL — sign_position must not be empty ──
        if (placementType === 'NORMAL' && (!sign.sign_position || sign.sign_position.trim() === '')) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Position Details Missing',
            detail: `Please select a sign position for signatory ${index + 1} before proceeding`,
          });
          return;
        }

        // ── EXISTING: Validate DRAG_DROP — position_details must not be empty ──
        if (
          sign.sign_position === DRAG_DROP &&
          Object.keys(sign.position_details).length === 0
        ) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Position details are not present',
            detail: 'Please select position details for all Signers before proceeding',
          });
          return;
        }

        // ── EXISTING: Catch leftover 'NORMAL' sign_position (safety net) ──
        if (sign.sign_position === 'NORMAL') {
          this.messageService.add({
            severity: 'warn',
            summary: 'Position details are not present',
            detail: 'Please select position details for all Signers before proceeding',
          });
          return;
        }

        if (
          sign.sign_position !== 'NORMAL' &&
          sign.sign_position !== 'DRAG_DROP'
        ) {
          if (sign.pages.trim().toUpperCase() === 'ALL') {
            sign.pages = 'ALL';
          } else {
            const parsedPages = this.parsePageRange(sign.pages);
            sign.pages = parsedPages.join(',');
            parsedPages.forEach((page) => {
              sign.position_details[page] = [{ ...this.positionData }];
            });
          }

          let pagesArray = sign.pages.split(',').map(String);

          if (
            sign.method === 'AADHAAR' ||
            sign.method === 'DSC' ||
            sign.method === 'ELECTRONIC'
          ) {
            const rect = this.getSignatureRect(
              sign.method,
              sign.sign_position,
              this.STANDARD_PAGE_WIDTH,
              this.STANDARD_PAGE_HEIGHT
            );
            this.positionData = rect;
            pagesArray.forEach((page) => {
              sign.position_details[page] = [{ ...rect }];
            });
          }
        }

        sign.position_details = Object.fromEntries(
          Object.entries(sign.position_details).filter(
            ([key, value]) => (value as []).length > 0,
          ),
        );

        if (!this.displayOrderIndex) {
          sign.signatory_sequence = 0;
        }

        if (sign.additional_fields.official_document_name) {
          sign.additional_fields.Official_Document_Type =
            sign.additional_fields.official_document_name;
          delete sign.additional_fields.official_document_name;
        }

        let details = {
          name: sign.name,
          email: sign.email,
          contact_number: sign.contact_number,
          position_details: sign.position_details,
          is_authorised: !!sign.is_authorised,
          authorised_for: sign.is_authorised ? (sign.authorised_for || '') : '',
          sign_position: sign.sign_position,
          signatory_sequence: sign.signatory_sequence,
          send_document: sign.send_document,
          send_notification: sign.send_notification,
          method: sign.method,
          remark: sign.remark,
          reminder: sign.reminder,
          schedule_timestamp: '',
          esign_otp: this.otp_validation,
          pages: sign.pages,
          additional_fields: sign.additional_fields,
          server_side_siganture: sign.server_side_siganture,
          estamp_sign: (this.stampSignToggle && this.documentToBeStamped) ? (sign.estamp_sign || false) : false,
          aadhaar_digits: (sign.method === 'AADHAAR' && this.aadhaar_validation && this.isDocumentType === '003') 
            ? sign.aadhaar_digits 
            : '',
          cc_emails: [
            this.esignDetails.value.carbon_copy_0,
            this.esignDetails.value.carbon_copy_1,
          ].filter((email) => !!email),
          sign_mode:
            sign.method === 'DSC'
              ? 'USB-Token'
              : sign.method === 'ELECTRONIC'
                ? ''
                : sign.sign_mode,
        };

        if (this.displayMailSchedule) {
          details.schedule_timestamp = this.dateFormetService.formatDateTime(
            sign.schedule_timestamp,
          );
        } else {
          details.schedule_timestamp = '';
        }

        data.signatoryDetails.push(details);
      }

      const esignData = this.esignDetails.value;
      this.esignDetails.value.addPartyDetailsForm.forEach((party) => {
        party.position_details = Object.fromEntries(
          Object.entries(party.position_details).filter(
            ([key, value]) => (value as []).length > 0,
          ),
        );
        if (party.signature_placement_type == DRAG_DROP) {
          var pages: any = [];
          for (let key in party.position_details) {
            if (party.position_details.hasOwnProperty(key)) {
              pages.push(key);
            }
          }
          party.pages = pages.join(',');
        }
      });
      esignData.party_users = this.esignDetails.value.addPartyDetailsForm;
      esignData.witness_users = this.esignDetails.value.addWitnessDetailsForm;
      esignData.party_users.concat(esignData.witness_users);
      esignData.signatory_details = data.signatoryDetails;
      esignData.placeOrder = true;

      this.sendSignDetails(esignData);
    } else {
      this.sendSignDetails(data);
    }
  }

  get isSignaturePlacementInvalid(): boolean {
    if (this.esignedNo) return false;

    const partyDetails = this.partyDetailsArray().controls;
    const witnessDetails = this.witnessDetailsArray().controls;
    const allSigners = [...partyDetails, ...witnessDetails];

    // If there are no signers, we shouldn't place an order
    if (allSigners.length === 0) return true;

    return allSigners.some(control => {
      const placementType = control.get('signature_placement_type')?.value;
      const signPosition = control.get('sign_position')?.value;
      const positionDetails = control.get('position_details')?.value;

      if (placementType === 'DRAG_DROP') {
        // Invalid if no drag-drop coordinates exist
        return !positionDetails || Object.keys(positionDetails).length === 0;
      } else {
        // Invalid if using Predefined (NORMAL) but no position is selected
        return !signPosition || signPosition === '' || signPosition === 'NORMAL';
      }
    });
  }


  //---------------------------------------------------------------------------------------------------------------//

  /*------------------------------- add Party End --------------------------------------------*/

  /*----------------------------------Placement type --------------------------------------*/

  getPlacementType(i: number) {
    const partyDetails = this.partyDetailsArray().value;
    const formGroup = this.partyDetailsArray().at(i);
    const currentPlacementType = formGroup.get(
      'signature_placement_type',
    )?.value;
    const existingPositionDetails = formGroup.get('position_details')?.value;
    const slotId = formGroup.get('signatory_sequence')?.value ?? i + 1;
    const absoluteIndex = slotId - 1;

    if (currentPlacementType === 'NORMAL') {
      // Switching away from drag-drop: clear state unconditionally
      const hasSignatures =
        this.signatureStateService.hasSignatures(absoluteIndex);
      if (hasSignatures) {
        this.signatureStateService.clearSignatureState(absoluteIndex);
      }

      formGroup.get('position_details')?.setValue({});
      formGroup.get('isSignaturePlacementDone')?.setValue(false);

      Object.keys(this.signPlacementDetails).forEach((pageNumber) => {
        const pageArray = this.signPlacementDetails[pageNumber];
        if (pageArray && Array.isArray(pageArray)) {
          const slotIndex = pageArray.findIndex(
            (s: any) => s && s.id === slotId,
          );
          if (slotIndex >= 0) {
            pageArray[slotIndex] = {
              id: slotId,
              signBoxList: [],
              name: '',
              dimension: null,
            };
          }
        }
      });
    } else if (currentPlacementType === 'DRAG_DROP') {
      // DRAG_DROP branch
      formGroup.get('sign_position')?.setValue('');

      if (
        !existingPositionDetails ||
        Object.keys(existingPositionDetails).length === 0
      ) {
        formGroup.get('position_details')?.setValue({});
      }

      // FIX: Only initialize slot if it doesn't exist — do NOT clear existing signatures
      Object.keys(this.signPlacementDetails).forEach((pageNumber) => {
        const pageArray = this.signPlacementDetails[pageNumber];
        if (pageArray && Array.isArray(pageArray)) {
          const existingSlot = pageArray.find((s: any) => s && s.id === slotId);
          if (!existingSlot) {
            pageArray.push({
              id: slotId,
              signBoxList: [],
              name: formGroup.get('name')?.value || '',
              dimension: null,
            });
          }
          // If slot already exists with signBoxList data, leave it untouched
        }
      });

      const alreadyHasSignatures =
        this.signatureStateService.hasSignatures(absoluteIndex);
      if (!alreadyHasSignatures) {
        this.signatureStateService.clearSignatureState(absoluteIndex);
        formGroup.get('isSignaturePlacementDone')?.setValue(false);
      }
      // If alreadyHasSignatures is true: preserve state — do NOT reset button
    }
    // else if (currentPlacementType === 'DEFAULT') {
    //   // const loc = this.generateDefaultPosition(i);
    //   // ✅ ALWAYS assign to page 1 (like default expectation)
    //   // const positionDetails = {
    //   //   1: [loc],
    //   // };
    //   const positionDetails = {
    //     1: [{ x1: 0, y1: 0, x2: 0, y2: 0 }]
    //   };

    //   // ✅ DIRECTLY SET (no dependency on signPlacementDetails)
    //   formGroup.get('position_details')?.setValue(positionDetails);
    //   formGroup.get('isSignaturePlacementDone')?.setValue(true);

    //   // ✅ also update UI structure if needed
    //   // if (!this.signPlacementDetails['1']) {
    //   //   this.signPlacementDetails['1'] = [];
    //   // }

    //   // const slotId = formGroup.get('signatory_sequence')?.value || (i + 1);

    //   // const pageArray = this.signPlacementDetails['1'];
    //   // const existingIndex = pageArray.findIndex((s: any) => s.id === slotId);

    //   // const newSlot = {
    //   //   id: slotId,
    //   //   signBoxList: [loc],
    //   //   name: formGroup.get('name')?.value || '',
    //   //   dimension: loc,
    //   // };

    //   // if (existingIndex >= 0) {
    //   //   pageArray[existingIndex] = newSlot;
    //   // } else {
    //   //   pageArray.push(newSlot);
    //   // }

    //   // formGroup.get('isSignaturePlacementDone')?.setValue(true);

    //   // console.log('FINAL DEFAULT', {
    //   //   i,
    //   //   loc,
    //   //   positionDetails
    //   // });
    // }

    this.rebuildSignatoryPositions();

    const partyDetail = partyDetails[i];
    if (partyDetail) {
      this.showPredefined[i] = partyDetail.signature_placement_type === 'NORMAL';
      //this.showSelectPage[i] = partyDetail.signature_placement_type !== 'DRAG_DROP'
    }
    this.updatePredefinedOptionState();
    console.log('Dekhiba getPlacementType', this.signPlacementDetails);
  }

  // generateDefaultPosition(index: number) {
  //   const maxPerRow = 5;

  //   const row = Math.floor(index / maxPerRow);
  //   const col = index % maxPerRow;

  //   const startX = 5;
  //   const boxWidth = 110;
  //   const gapX = 5;

  //   const startY = 740; // bottom
  //   const rowHeight = 50;

  //   const x1 = startX + col * (boxWidth + gapX);
  //   const x2 = x1 + boxWidth;

  //   const y1 = startY - row * rowHeight;
  //   const y2 = y1 + 70;

  //   return { x1, y1, x2, y2 };
  // }

  getSignMethod(i: number) {
    this.showMethod[i] = false;
    const partyDetails = this.partyDetailsArray().value[i];
    if (partyDetails.method === 'AADHAAR') {
      this.showMethod[i] = true;
    } else {
      this.showMethod[i] = false;
    }
  }

  getPlacementTypeWitness(i: number) {
    this.showPredefinedWitness[i] = false;
    const witnessDetails = this.witnessDetailsArray().value[i];
    if (witnessDetails.sign_position === 'NORMAL') {
      this.showPredefinedWitness[i] = true;
    } else {
      this.showPredefinedWitness[i] = false;
    }
  }
  //---------------------------------------------------------------------------------------------//
  /*------------------------------- add witness Details --------------------------------------------*/

  removeWitnessDetails(index: number) {
    this.witnessDetailsArray().removeAt(index);
    if (index === 0) {
      this.showWitnessDetails = false;
    }
  }

  witnessDetailsArray(): FormArray {
    return this.esignDetails.get('addWitnessDetailsForm') as FormArray;
  }

  addNewWitnessDetails() {
    const checkIndex = this.witnessDetailsArray().length - 1;
    const partyDetails = this.partyDetailsArray().value;
    const witnessDetails = this.witnessDetailsArray().value;

    if (this.witnessDetailsArray().length != 0) {
      const esignValue = this.witnessDetailsArray().value[checkIndex];
      if (esignValue.sign_position === 'NORMAL') {
        if (Object.keys(esignValue.position_details).length === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Witness Details',
            detail: 'Please Select Positon to sign',
          });
          return;
        }
      } else {
        this.showWitnessDetails = true;
        if (this.esignDetails.controls['addWitnessDetailsForm'].valid) {
          this.witnessDetailsArray().push(this.initPartyDetails('WITNESS'));
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Witness Details',
            detail: 'Please fill Witness details before adding New',
          });
        }
      }
    } else {
      this.showWitnessDetails = true;
      if (this.esignDetails.controls['addWitnessDetailsForm'].valid) {
        this.witnessDetailsArray().push(this.initPartyDetails('WITNESS'));
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Witness Details',
          detail: 'Please fill Witness details before adding New',
        });
      }
    }
  }
  /*------------------------------- add witness End --------------------------------------------*/

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  toSignerToPay(value: boolean) {
    // this.showPaymentDetails = value;
    this.esignDetails.controls.paymentbySigner.setValue(
      this.showPaymentDetails && this.showPayment,
    );
    if (!value) {
      this.esignDetails.patchValue({
        payeeName: '',
        payeeEmail: '',
        payeeMobileNumber: '',
      });
    }
    this.storageService.getSignerValue.next(value);
  }

  paymentMethod(value: string) {
    const isGateway =
      value === this.paymentbyRazorpay || value === 'HDFC_GATEWAY';

    if (isGateway) {
      this.showPaymentDetails = true;
      // Ensure the string matches what your backend expects
      this.storageService.setSelectedProvider(
        value === 'HDFC_GATEWAY' ? 'HDFC_GATEWAY' : 'RAZORPAY_GATEWAY',
      );
    } else {
      this.showPaymentDetails = false;
      this.clearPaymentFields();
    }

    this.esignDetails.controls.paymentMethod.setValue(value);

    const isPayLater = value === this.payLater;
    this.esignDetails.controls.paymentbySigner.setValue(!isPayLater);
    this.storageService.getSignerValue.next(!isPayLater);
  }

  private clearPaymentFields() {
    this.esignDetails.controls.payeeName?.setValue('');
    this.esignDetails.controls.payeeEmail?.setValue('');
    this.esignDetails.controls.payeeMobileNumber?.setValue('');

    this.esignDetails.controls.payeeName?.markAsUntouched();
    this.esignDetails.controls.payeeName?.markAsPristine();
    this.esignDetails.controls.payeeName?.updateValueAndValidity();

    this.esignDetails.controls.payeeEmail?.markAsUntouched();
    this.esignDetails.controls.payeeEmail?.markAsPristine();
    this.esignDetails.controls.payeeEmail?.updateValueAndValidity();

    this.esignDetails.controls.payeeMobileNumber?.markAsUntouched();
    this.esignDetails.controls.payeeMobileNumber?.markAsPristine();
    this.esignDetails.controls.payeeMobileNumber?.updateValueAndValidity();
  }

  tobeEsigned(value: boolean) {
    this.isEsigned = value;
    this.showPaymentDetails = true;
    let providers = this.getAvailableProviders();
    let paymentOption = this.is_wallet
      ? this.paymentbyWallet
      : this.showPayment
        ? providers.includes('RAZORPAY_GATEWAY')
          ? this.paymentbyRazorpay
          : 'HDFC_GATEWAY'
        : this.payLater;
    this.esignDetails.controls.paymentMethod.setValue(paymentOption);
    if (paymentOption === this.payLater) {
      this.esignDetails.controls.paymentbySigner.setValue(false);
      this.storageService.getSignerValue.next(false);
    } else {
      if (paymentOption === this.paymentbyRazorpay) {
        this.showPaymentDetails = true;
      }
      this.esignDetails.controls.paymentbySigner.setValue(true);
      this.storageService.getSignerValue.next(true);
    }
    if (!this.isEsigned && this.isStampPreProcured) {
      this.hidePaymentMethod = false;
      this.storageService.setHidePaymentMethod(true);
      this.esignDetails.controls.paymentMethod.setValue(
        providers.includes('RAZORPAY_GATEWAY')
          ? this.paymentbyRazorpay
          : 'HDFC_GATEWAY',
      );
      this.esignDetails.controls.paymentbySigner.setValue(false);
      this.storageService.getSignerValue.next(false);
    }
    let esignedYes = <HTMLInputElement>document.getElementById('esignedYes');
    let esignedNo = <HTMLInputElement>document.getElementById('esignedNo');
    if (this.isEsigned) {
      this.showPlaceOrder = true;
      this.partyDetailsArray().push(this.initPartyDetails('PARTY'));
      this.getDefaultFieldData(this.account_id);
      esignedYes.checked = true;
      esignedNo.checked = false;
      this.esignedYes = true;
      this.esignedNo = false;
      this.hidePaymentMethod = false;
      this.storageService.setHidePaymentMethod(false);
    } else {
      this.partyDetailsArray().clear();
      this.witnessDetailsArray().clear();
      esignedYes.checked = false;
      esignedNo.checked = true;
      this.esignedYes = false;
      this.esignedNo = true;
      this.showPlaceOrder = false;
      this.showPaymentDetails = true;
      // if (
      //   paymentOption === this.paymentbyRazorpay && !this.isStampPreProcured
      // ) {
      //   this.showPaymentDetails = true;
      // } else {
      //   this.showPaymentDetails = false;
      // }
    }
  }

  payNowOrlater(value: boolean) {
    this.isPayNowOrLater = value;
    let payNow = <HTMLInputElement>document.getElementById('payNow');
    let payLater = <HTMLInputElement>document.getElementById('payLater');
    if (this.isPayNowOrLater) {
      payNow.checked = true;
      payLater.checked = false;
      this.isPayNow = true;
      this.isPayLater = false;
    } else {
      payNow.checked = false;
      payLater.checked = true;
      this.isPayNow = false;
      this.isPayLater = true;
    }
  }

  back() {
    this.esignData = this.esignDetails.value;
    this.esignData.placeOrder = false;
    if (this._location.path() == '/doqfy/e-sign/form') {
      this.esignData.page = 'upload';
    } else {
      this.esignData.page = 'estamp';
    }
    this.catUploadService.setEsignFormData(this.esignData);

    this.esignDataChange.emit(this.esignData);
  }

  placeOrder() {
    this.submitted = true;
    if (this.esignDetails.invalid) {
      return;
    }
    const partyDetails = this.partyDetailsArray().value;
    const witnessDetails = this.witnessDetailsArray().value;
    const esignData = this.esignDetails.value;
    esignData.party_users = this.esignDetails.value.addPartyDetailsForm;
    esignData.witness_users = this.esignDetails.value.addWitnessDetailsForm;
    esignData.party_users.concat(esignData.witness_users).forEach((party) => {
      if (party.sign_position == DRAG_DROP) {
        var pages: any = [];
        for (let key in party.position_details) {
          pages.push(key);
        }
        party.pages = pages.join(',');
      }
    });
    this.sendSignDetails(esignData);
  }

  sendSignDetails(data: any) {
    data.toBeEsigned = this.isEsigned;
    data.page = 'confirmation';
    this.esignDataChange.emit(data);
  }

  /**
   * Check if form is valid including carbon copy validation
   */
  getActivePlaceOrder() {
    let isFormValid = this.esignDetails.valid;

    // Additional validation for carbon copy when enabled
    if (this.isCarbonCopy) {
      const carbonCopyValid = this.isCarbonCopyValid();
      isFormValid = isFormValid && carbonCopyValid;
    }
    // Additional validation for payment fields when payment by signer is enabled
    if (this.showPaymentDetails && this.showPayment) {
      const paymentValid = this.isPaymentFieldsValid();
      isFormValid = isFormValid && paymentValid;
    }

    if (isFormValid) {
      this.showPlaceOrder = false;
      this.submitted = true;
    } else {
      this.showPlaceOrder = true;
    }
  }

  private isPaymentFieldsValid(): boolean {
    const payeeName = this.esignDetails.get('payeeName');
    const payeeEmail = this.esignDetails.get('payeeEmail');
    const payeeMobileNumber = this.esignDetails.get('payeeMobileNumber');

    // Check if all payment fields have values
    const hasPayeeName =
      payeeName && payeeName.value && payeeName.value.trim() !== '';
    const hasPayeeEmail =
      payeeEmail && payeeEmail.value && payeeEmail.value.trim() !== '';
    const hasPayeeMobile =
      payeeMobileNumber &&
      payeeMobileNumber.value &&
      payeeMobileNumber.value.trim() !== '';

    if (!hasPayeeName || !hasPayeeEmail || !hasPayeeMobile) {
      return false;
    }

    // Check if fields are valid (no validation errors)
    const isPayeeNameValid = payeeName ? payeeName.valid : false;
    const isPayeeEmailValid = payeeEmail ? payeeEmail.valid : false;
    const isPayeeMobileValid = payeeMobileNumber
      ? payeeMobileNumber.valid
      : false;

    return isPayeeNameValid && isPayeeEmailValid && isPayeeMobileValid;
  }
  /**
   * Check if carbon copy fields are valid
   */
  private isCarbonCopyValid(): boolean {
    // Check if all carbon copy fields have values and are valid emails
    for (let i = 0; i < this.carbonCopyControlsCount; i++) {
      const controlName = `carbon_copy_${i}`;
      const control = this.esignDetails.get(controlName);

      if (!control || !control.value || control.value.trim() === '') {
        return false; // Required field is empty
      }

      if (control.invalid) {
        return false; // Field has validation errors
      }
    }

    // Check for duplicates and invalid emails using your existing methods
    if (this.hasDuplicateEmails() || this.hasInvalidEmails()) {
      return false;
    }

    return true;
  }

  //------------------------------ User for number field ---------------------------------//
  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  numberOnlyWithComma(event: any) {
    const pattern = /[0-9,-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  parsePageRange(input: string): number[] {
    const pages: number[] = [];
    const parts = input.split(',');

    parts.forEach((part) => {
      if (part.includes('-')) {
        const [start, end] = part.split('-').map(Number);
        if (!isNaN(start) && !isNaN(end) && start <= end) {
          for (let i = start; i <= end; i++) {
            pages.push(i);
          }
        }
      } else {
        const page = Number(part);
        if (!isNaN(page)) {
          pages.push(page);
        }
      }
    });

    return [...new Set(pages)].sort((a, b) => a - b); // remove duplicates and sort
  }

  SetPageALL(index) {
    const formArray = this.esignDetails.get('addPartyDetailsForm') as FormArray;

    if (formArray && formArray.at(index)) {
      formArray.at(index).patchValue({ pages: 'ALL' });
      this.onPredefinedPagesChange(index);
    }
  }

  OnlyOneNumber(event: any) {
    const pattern = /^[0-9]$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  //-----------------------------------Drag and drop -------------------------------------------------------//

  assignSignatures(content: any) {
    let allSigners: any = this.esignDetails.controls['addPartyDetailsForm'].value
      .concat(this.esignDetails.controls['addWitnessDetailsForm'].value);

    this.signerNames = allSigners.map((o: any, index: number) =>
      this.getShortSignerName(o?.name, index),
    );

    // Pre-Defined positions are not placeable here, but they must stay visible
    // as reference markers so a custom box isn't dropped on top of one.
    this.buildPredefinedReferenceMarkers();

    // FIX: Only pass signers who have DRAG_DROP placement type
    this.dragDropSignerNames = allSigners
      .map((o: any, index: number) => {
        const displayName = this.getShortSignerName(o?.name, index);

        const formControl = this.partyDetailsArray().at(index);
        const placementType = formControl
          ? formControl.get('signature_placement_type')?.value
          : o.signature_placement_type;

        // Use signatory_sequence (stable across deletions/reorders) not array index
        const signatorySequence = o.signatory_sequence ?? (index + 1);
        return {
          name: displayName,
          absoluteIndex: signatorySequence - 1,
          placementType: placementType,
          isReadOnly: false,
        };
      })
      .filter((s: any) => s.placementType === 'DRAG_DROP'); // FIX: Only DRAG_DROP signers

    Object.keys(this.signPlacementDetails).forEach((pageNumber) => {
      const pageArray = this.signPlacementDetails[pageNumber];
      if (pageArray && Array.isArray(pageArray)) {
        allSigners.forEach((signer: any, index: number) => {
          const slotId = signer.signatory_sequence ?? (index + 1);
          const existingSlot = pageArray.find((s: any) => s && s.id === slotId);
          if (!existingSlot) {
            pageArray.push({
              id: slotId,
              signBoxList: [],
              name: this.signerNames[index] || '',
              dimension: null,
            });
          }
        });
      }
    });

    this.signPlacementSnapshot = JSON.parse(JSON.stringify(this.signPlacementDetails));

    if (this.showCatEdit) {
      this.orderService
        .getEditTemplatePDFDocument(this.esignData.pdfData)
        .subscribe((resp: any) => {
          // Pass the raw base64 string directly — pdf-virtual-viewer's
          // normalizeInput() handles base64 strings correctly, but cannot
          // decode blob: URLs (it calls atob() which fails on them).
          this.pdfSource = resp.content.document_url;
          this.modalService
            .open(content, {
              size: 'xxl',
              fullscreen: true,
              ariaLabelledBy: 'modal-basic-title',
              backdrop: 'static',
              keyboard: false,
            })
            .result.then(() => {}, () => {});
        });
    } else {
      this.getCatUploadPdf(content);
    }
  }
  private getShortSignerName(rawName: any, index: number): string {
    const name = (rawName ?? '').toString().trim();
    if (name.length === 0) {
      return `Signatory ${index + 1}`;
    }
    const nameParts = name.split(' ').filter((part: string) => part.length > 0);
    if (nameParts.length === 1) {
      return nameParts[0];
    }
    return `${nameParts[0]} ${nameParts[nameParts.length - 1].charAt(0).toUpperCase()}`;
  }
  
  /**
   * Where a Pre-Defined signature really lands, in top-down page coordinates, so
   * the Drag & Drop screen draws its marker at the true position and size. Built
   * from the same getSignatureRect() that produces the submitted position_details,
   * rather than from separate marker-only sizes that had drifted out of step.
   */
  private getPredefinedMarkerRect(
    method: string,
    signPosition: string
  ): {
    x1: number;
    x2: number;
    y1: number;
    y2: number;
  } {
    const pageWidth = this.STANDARD_PAGE_WIDTH;
    const pageHeight = this.STANDARD_PAGE_HEIGHT;
    const upperMethod = (method || '').toString().toUpperCase();
    const signMethod: 'ELECTRONIC' | 'AADHAAR' | 'DSC' =
      upperMethod === 'AADHAAR' || upperMethod === 'DSC' ? upperMethod : 'ELECTRONIC';

    const rect = this.getSignatureRect(signMethod, signPosition, pageWidth, pageHeight);

    // Electronic rects are already top-down; Aadhaar/DSC ones are bottom-up (PDF).
    if (signMethod === 'ELECTRONIC') {
      return rect;
    }
    return {
      x1: rect.x1,
      x2: rect.x2,
      y1: pageHeight - rect.y2,
      y2: pageHeight - rect.y1,
    };
  }

  /**
   * Builds read-only markers for every signatory using Pre-Defined placement, so
   * the Custom (Drag & Drop) screen can show where signatures already sit.
   */
  private buildPredefinedReferenceMarkers(): void {
    this.predefinedReferenceMarkers = [];

    // Default placement isn't combinable with drag & drop, nothing to show.
    if (this.isDefaultSignatureSelected) {
      return;
    }

    const controls = [
      ...this.partyDetailsArray().controls,
      ...this.witnessDetailsArray().controls,
    ];

    const markers: PredefinedReferenceMarker[] = [];

    controls.forEach((control, index) => {
      if (control.get('signature_placement_type')?.value !== 'NORMAL') {
        return;
      }

      const signPosition = (control.get('sign_position')?.value ?? '')
        .toString()
        .trim()
        .toUpperCase();
      if (
        !signPosition ||
        signPosition === 'NORMAL' ||
        signPosition === DRAG_DROP ||
        signPosition === 'DEFAULT'
      ) {
        return;
      }

      const rect = this.getPredefinedMarkerRect(control.get('method')?.value, signPosition);

      markers.push({
        name: this.getShortSignerName(control.get('name')?.value, index),
        positionLabel: this.getPositionDisplayName(signPosition),
        xFraction: rect.x1 / this.STANDARD_PAGE_WIDTH,
        yFraction: rect.y1 / this.STANDARD_PAGE_HEIGHT,
        widthFraction: (rect.x2 - rect.x1) / this.STANDARD_PAGE_WIDTH,
        heightFraction: (rect.y2 - rect.y1) / this.STANDARD_PAGE_HEIGHT,
        pages: this.resolveMarkerPages(control.get('pages')?.value),
      });
    });

    this.predefinedReferenceMarkers = markers;
  }

  private resolveMarkerPages(pagesValue: any): 'ALL' | number[] {
    const raw = (pagesValue ?? '').toString().trim();
    if (!raw || raw.toUpperCase() === 'ALL') {
      return 'ALL';
    }
    const parsed = this.parsePageRange(raw);
    return parsed.length > 0 ? parsed : 'ALL';
  }

  private getPositionDisplayName(positionCode: string): string {
    const match = this.displaySigningPositions.find(
      (position: any) => position.position_code === positionCode,
    );
    if (match?.display_name) {
      return match.display_name;
    }
    return positionCode
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (char: string) => char.toUpperCase());
  }

  onSignaturePlacementSuccess(signatoryIndex: number) {
    // Set the flag for the specific signatory
    this.partyDetailsArray()
      .at(signatoryIndex)
      .get('isSignaturePlacementDone')
      .setValue(true);
  }

  hasSignaturesPlaced(signatoryIndex: number): boolean {
    return this.signatureStateService.hasSignatures(signatoryIndex);
  }

  // Method to get signature count for display
  getSignatureCount(signatoryIndex: number): number {
    return this.signatureStateService.getSignatureCount(signatoryIndex);
  }

  getButtonLabel(signatoryIndex: number): string {
    const hasSignatures = this.hasSignaturesPlaced(signatoryIndex);
    const isPlacementDone = this.partyDetailsArray()
      .at(signatoryIndex)
      .get('isSignaturePlacementDone')?.value;

    if (hasSignatures) {
      return 'Signature Assigned';
    }
    return 'Assign Signatures';
  }

  // Method to determine button style class
  getButtonStyleClass(signatoryIndex: number): string {
    const hasSignatures = this.hasSignaturesPlaced(signatoryIndex);
    const isPlacementDone = this.partyDetailsArray()
      .at(signatoryIndex)
      .get('isSignaturePlacementDone')?.value;

    if (hasSignatures) {
      return 'p-button-sm signature-assigned-btn';
    }
    return 'p-button-sm';
  }

  shouldShowCheckmark(signatoryIndex: number): boolean {
    const hasSignatures = this.hasSignaturesPlaced(signatoryIndex);
    return hasSignatures;
  }

  isButtonDisabled(signatoryIndex: number): boolean {
    // Button should never be disabled to allow reassignment
    return false;
  }

  getButtonTooltip(signatoryIndex: number): string {
    const hasSignatures = this.hasSignaturesPlaced(signatoryIndex);
    const isPlacementDone = this.partyDetailsArray()
      .at(signatoryIndex)
      .get('isSignaturePlacementDone')?.value;

    if (hasSignatures) {
      return 'Click to reassign signatures';
    }
    return 'Click to assign signatures';
  }

  getCatUploadPdf(content) {
    const pdfData = this.esignData.pdfData;

    // In the CAT Compose flow, esignData.pdfData is a template descriptor
    // object ({ template_id, fields }) produced by template-edit, not a
    // base64 PDF string. Passing that object straight to app-drag-drop ->
    // app-pdf-virtual-viewer breaks normalizeInput() ("data.includes is not
    // a function") and the document never renders. Resolve the template into
    // its rendered PDF first — same call the CAT Edit branch uses.
    if (pdfData && typeof pdfData === 'object') {
      this.orderService.getEditTemplatePDFDocument(pdfData).subscribe((resp: any) => {
        const templateBase64 = resp?.content?.document_url;
        const composedDocuments = this.esignData?.composedDocuments;

        // CAT Compose can bundle uploaded PDFs/images alongside the template.
        // Merge them into a single preview so "Assign Signatures" shows the
        // whole document (template + uploads), not just the template — and in
        // the same order the backend merges at placement time.
        const hasExtras =
          Array.isArray(composedDocuments) &&
          composedDocuments.some((d: any) => d && d.type !== 'template' && d.base64);

        if (hasExtras) {
          this.composePreviewService
            .buildCombinedPdf(templateBase64, composedDocuments)
            .then((combined) => {
              this.pdfSource = combined;
              this.openCatUploadModal(content);
              this.cdr.detectChanges();
            })
            .catch(() => {
              // Fall back to at least showing the template if merging fails.
              this.pdfSource = templateBase64;
              this.openCatUploadModal(content);
              this.cdr.detectChanges();
            });
          return;
        }

        this.pdfSource = templateBase64;
        this.openCatUploadModal(content);
      });
      return;
    }

    this.pdfSource = pdfData;
    this.openCatUploadModal(content);
  }

  private openCatUploadModal(content: any) {
    this.modalService
      .open(content, {
        size: 'xxl',
        fullscreen: true,
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {},
        (reason) => {},
      );
  }

  getSignerCount() {
    return (
      this.esignDetails.controls['addPartyDetailsForm'].value.length +
      this.esignDetails.controls['addWitnessDetailsForm'].value.length
    );
  }

  mapDigioPositions() {
    this.placeSignPostion = {
      partyEmails: this.esignDetails.controls['addPartyDetailsForm'].value,
      witnessEmails: this.esignDetails.controls['addWitnessDetailsForm'].value,
      document_name: 'Agreement',
      number_of_days: 7,
      purpose: 'Agreement',
      signature_display_type: '',
    };

    const filteredSignPlacementDetails: any = {};
    for (const [key, value] of Object.entries(this.signPlacementDetails)) {
      const filteredSignBoxList = (value as any[]).filter(
        (item) => item && item.signBoxList && item.signBoxList.length > 0,
      );
      if (filteredSignBoxList.length > 0) {
        filteredSignPlacementDetails[key] = filteredSignBoxList;
      }
    }

    const signatureCountMap = new Map<number, number>();

    for (var i = 0; i < this.getSignerCount(); i++) {
      const currentSigner =
        i < this.placeSignPostion.partyEmails.length
          ? this.placeSignPostion.partyEmails[i]
          : this.placeSignPostion.witnessEmails[
              i - this.placeSignPostion.partyEmails.length
            ];

      if (currentSigner.signature_placement_type === 'DRAG_DROP') {
        let totalSignaturesForSigner = 0;

        if (i < this.placeSignPostion.partyEmails.length) {
          if (!this.placeSignPostion.partyEmails[i].position_details) {
            this.placeSignPostion.partyEmails[i].position_details = {};
          }
          Object.keys(filteredSignPlacementDetails).forEach((pageKey) => {
            this.placeSignPostion.partyEmails[i].position_details[pageKey] = [];
          });
        } else {
          const witnessIndex = i - this.placeSignPostion.partyEmails.length;
          if (
            !this.placeSignPostion.witnessEmails[witnessIndex].position_details
          ) {
            this.placeSignPostion.witnessEmails[witnessIndex].position_details =
              {};
          }
          Object.keys(filteredSignPlacementDetails).forEach((pageKey) => {
            this.placeSignPostion.witnessEmails[witnessIndex].position_details[
              pageKey
            ] = [];
          });
        }

        for (let [pageKey, pageSignatures] of Object.entries(
          filteredSignPlacementDetails,
        )) {
          const stableSignatoryId = currentSigner.signatory_sequence ?? (i + 1);
          const signerOnPage = (pageSignatures as any[]).find(
            (o) => o && o.id === stableSignatoryId,
          );

          if (
            signerOnPage &&
            signerOnPage.signBoxList &&
            signerOnPage.signBoxList.length > 0
          ) {
            const positionsToUse = signerOnPage.signBoxList;

            for (var j = 0; j < positionsToUse.length; j++) {
              const signBox = positionsToUse[j];
              if (!signBox.position) continue;

              const x = Math.round(
                Number(this.convertPxToPt(signBox.position.x + 2)),
              );
              const y = Math.round(
                Number(this.convertPxToPt(signBox.position.y + 2)),
              );

              // The box dragged on screen is drawn at exactly this size (see
              // drag-drop.component), so the stamped signature matches it.
              const signWidth = SIGNATURE_BOX_WIDTH_PT;
              const signHeight = SIGNATURE_BOX_HEIGHT_PT;

              let transformedCoordinate;
              if (currentSigner.method.toUpperCase() === 'ELECTRONIC') {
                const constrained = this.constrainToA4Boundaries(x, y, signWidth, signHeight);
                transformedCoordinate = constrained;
              } else {
                const pageHeight = signerOnPage.dimension
                  ? signerOnPage.dimension.height
                  : this.STANDARD_PAGE_HEIGHT;
                const constrained = this.constrainToA4Boundaries(x, y, signWidth, signHeight);
                transformedCoordinate = {
                  x1: constrained.x1,
                  x2: constrained.x2,
                  y2: Math.round(Number(pageHeight - constrained.y1)),
                  y1: Math.round(Number(pageHeight - constrained.y2)),
                };
              }

              if (i < this.placeSignPostion.partyEmails.length) {
                this.placeSignPostion.partyEmails[i].position_details[
                  pageKey
                ].push(transformedCoordinate);
              } else {
                const witnessIndex =
                  i - this.placeSignPostion.partyEmails.length;
                this.placeSignPostion.witnessEmails[
                  witnessIndex
                ].position_details[pageKey].push(transformedCoordinate);
              }

              totalSignaturesForSigner++;
            }
          }
        }

        signatureCountMap.set(i, totalSignaturesForSigner);
      }
    }

    // FIX: Use signatory_sequence to find the correct form array index,
    // instead of assuming form array index === absolute signatory index i.
    // This prevents setting isSignaturePlacementDone on the wrong form group
    // when witnesses exist or signatories have been deleted/reordered.
    for (let i = 0; i < this.getSignerCount(); i++) {
      const currentSigner =
        i < this.placeSignPostion.partyEmails.length
          ? this.placeSignPostion.partyEmails[i]
          : this.placeSignPostion.witnessEmails[
              i - this.placeSignPostion.partyEmails.length
            ];

      // FIX: Find the correct form array index by matching signatory_sequence
      // signatory_sequence was set at creation = absoluteIndex+1 = i+1
      const currentSignatorySequence = currentSigner.signatory_sequence ?? (i + 1);
      const formArrayIndex =
        i < this.placeSignPostion.partyEmails.length
          ? this.partyDetailsArray().controls.findIndex(
              (ctrl) => ctrl.get('signatory_sequence')?.value === currentSignatorySequence,
            )
          : -1;

      if (currentSigner.signature_placement_type === 'DRAG_DROP') {
        const count = signatureCountMap.get(i) ?? 0;
        const hasSignatures = count > 0;

        this.signatureStateService.updateSignatureState(
          i,
          hasSignatures,
          count,
        );

        // FIX: Use resolved formArrayIndex, not raw i
        if (formArrayIndex >= 0) {
          this.partyDetailsArray()
            .at(formArrayIndex)
            .get('isSignaturePlacementDone')
            ?.setValue(hasSignatures);
        }
      } else {
        // Predefined: clear state but do NOT touch isSignaturePlacementDone
        // (predefined signatories never have isSignaturePlacementDone = true anyway)
        this.signatureStateService.clearSignatureState(i);
        // FIX: Do NOT reset isSignaturePlacementDone for predefined — it's always false
        // and calling setValue(false) here was unnecessarily dirtying the form.
      }
    }

    this.isSignaturePlacementDone = true;
    this.cdr?.detectChanges();
  }
  private constrainToA4Boundaries(
    x1: number,
    y1: number,
    signatureWidth: number = SIGNATURE_BOX_WIDTH_PT,
    signatureHeight: number = SIGNATURE_BOX_HEIGHT_PT,
  ) {
    const A4_WIDTH = 595;
    const A4_HEIGHT = 842;

    let constrainedX1 = x1;
    let constrainedY1 = y1;
    let constrainedX2 = x1 + signatureWidth;
    let constrainedY2 = y1 + signatureHeight;

    // Constrain X coordinates (width)
    if (constrainedX2 > A4_WIDTH) {
      constrainedX2 = A4_WIDTH;
      constrainedX1 = A4_WIDTH - signatureWidth;
    }
    if (constrainedX1 < 0) {
      constrainedX1 = 0;
      constrainedX2 = signatureWidth;
    }

    // Constrain Y coordinates (height)
    if (constrainedY2 > A4_HEIGHT) {
      constrainedY2 = A4_HEIGHT;
      constrainedY1 = A4_HEIGHT - signatureHeight;
    }
    if (constrainedY1 < 0) {
      constrainedY1 = 0;
      constrainedY2 = signatureHeight;
    }

    return {
      x1: Math.round(constrainedX1),
      x2: Math.round(constrainedX2),
      y1: Math.round(constrainedY1),
      y2: Math.round(constrainedY2),
    };
  }
  digioSignPosition(event) {
    this.mapDigioPositions();
    this.signPlacementSnapshot = null;
    // New drag & drop placements change which Pre-Defined positions are free.
    this.rebuildSignatoryPositions();
    this.modalService.dismissAll();
  }

  closeModel() {
    const selectedSigner = this.signerNames[0]; // Replace with actual selected signer logic if needed
    this.cancel(selectedSigner);
  }
  convertPxToPt(px: number) {
    return (3 / 4) * px;
  }

  cancel(_selectedSigner?: any) {
    if (this.signPlacementSnapshot) {
      // Restore signPlacementDetails to the exact state it was before the modal opened
      Object.keys(this.signPlacementDetails).forEach(k => delete this.signPlacementDetails[k]);
      const restored = JSON.parse(JSON.stringify(this.signPlacementSnapshot));
      Object.assign(this.signPlacementDetails, restored);

      // Restore SignatureStateService and isSignaturePlacementDone per signatory
      this.partyDetailsArray().controls.forEach((control, absoluteIndex) => {
        let totalCount = 0;
        Object.keys(this.signPlacementSnapshot).forEach(pageKey => {
          const pageData = this.signPlacementSnapshot[pageKey];
          if (pageData && Array.isArray(pageData)) {
            const signerData = pageData.find((s: any) => s && s.id === (absoluteIndex + 1));
            if (signerData?.signBoxList) totalCount += signerData.signBoxList.length;
          }
        });
        this.signatureStateService.updateSignatureState(absoluteIndex, totalCount > 0, totalCount);
        control.get('isSignaturePlacementDone')?.setValue(totalCount > 0, { emitEvent: false });
      });

      this.signPlacementSnapshot = null;
      this.rebuildSignatoryPositions();
    }
    this.modalService.dismissAll();
  }

  rebuildSignatoryPositions() {
    const partyDetails = this.partyDetailsArray().value;
    const count = this.partyDetailsArray().length;
    for (let i = 0; i < count; i++) {
      const takenByOthers = partyDetails
        .filter((_: any, idx: number) => idx !== i)
        .map((sign: any) => sign.sign_position)
        .filter((pos: any) => pos && pos !== 'DRAG_DROP' && pos !== 'DEFAULT' && pos !== 'NORMAL');
      // Positions that would overlap a drag & drop signature on one of this
      // signatory's pages stay listed but greyed out.
      const clashing = this.getDragDropClashingPositions(i);
      this.signatoryAvailablePositions[i] = this.displaySigningPositions
        .filter((opt: any) => !takenByOthers.includes(opt.position_code))
        .map((opt: any) =>
          clashing.has(opt.position_code)
            ? {
                ...opt,
                display_name: `${opt.display_name} (Already taken by Drag & Drop)`,
                disabled: true,
              }
            : { ...opt, disabled: false },
        );
    }
    this.signatoryAvailablePositions.length = count;
  }

  selectedSignPotion(currentIndex: number) {
    this.rejectDragDropClash(currentIndex);
    this.rebuildSignatoryPositions();
    this.updatePredefinedOptionState();
  }

  // Pages decide which drag & drop signatures a Pre-Defined position can clash
  // with, so a page change can turn an already selected position invalid.
  onPredefinedPagesChange(index: number) {
    this.rejectDragDropClash(index);
    this.rebuildSignatoryPositions();
    this.updatePredefinedOptionState();
  }

  /**
   * Clears the signatory's Pre-Defined position, with an error, when it overlaps
   * a drag & drop signature on any of its pages. Returns true if it did.
   */
  private rejectDragDropClash(index: number): boolean {
    const control = this.partyDetailsArray().at(index);
    if (!control || control.get('signature_placement_type')?.value !== 'NORMAL') {
      return false;
    }
    const signPosition = control.get('sign_position')?.value;
    if (!signPosition || !this.getDragDropClashingPositions(index).has(signPosition)) {
      return false;
    }
    control.get('sign_position')?.setValue('');
    this.messageService.add({
      severity: 'error',
      summary: 'Position Not Available',
      detail: `${this.getPositionDisplayName(signPosition)} is already taken by Drag & Drop for signatory ${index + 1}. Please choose another position.`,
    });
    return true;
  }

  /**
   * Position codes that, for this party signatory's method and pages, would
   * overlap a signature already placed via drag & drop on the same page.
   */
  private getDragDropClashingPositions(index: number): Set<string> {
    const clashing = new Set<string>();
    const control = this.partyDetailsArray().at(index);
    if (!control || this.isDefaultSignatureSelected) {
      return clashing;
    }

    const boxesByPage = this.getDragDropRectsByPage();
    if (boxesByPage.size === 0) {
      return clashing;
    }

    const pages = this.resolveMarkerPages(control.get('pages')?.value);
    const boxes =
      pages === 'ALL'
        ? Array.from(boxesByPage.values()).flat()
        : pages.flatMap((page) => boxesByPage.get(page) ?? []);
    if (boxes.length === 0) {
      return clashing;
    }

    const method = control.get('method')?.value;
    this.displaySigningPositions.forEach((opt: any) => {
      const rect = this.getPredefinedMarkerRect(method, opt.position_code);
      if (boxes.some((box) => this.rectsOverlap(rect, box))) {
        clashing.add(opt.position_code);
      }
    });
    return clashing;
  }

  /**
   * Drag & drop signatures per page, in the same top-down point coordinates as
   * getPredefinedMarkerRect(), converted the way mapDigioPositions() does.
   */
  private getDragDropRectsByPage(): Map<number, { x1: number; x2: number; y1: number; y2: number }[]> {
    const byPage = new Map<number, { x1: number; x2: number; y1: number; y2: number }[]>();

    // Slots of parties no longer on drag & drop are ignored.
    const nonDragDropIds = new Set(
      this.partyDetailsArray()
        .controls.map((ctrl, i) => ({
          id: ctrl.get('signatory_sequence')?.value ?? i + 1,
          type: ctrl.get('signature_placement_type')?.value,
        }))
        .filter((s) => s.type !== DRAG_DROP)
        .map((s) => s.id),
    );

    Object.entries(this.signPlacementDetails || {}).forEach(([pageKey, slots]) => {
      const page = Number(pageKey);
      if (!Array.isArray(slots) || isNaN(page)) {
        return;
      }
      slots.forEach((slot: any) => {
        if (!slot?.signBoxList?.length || nonDragDropIds.has(slot.id)) {
          return;
        }
        slot.signBoxList.forEach((signBox: any) => {
          if (!signBox?.position) {
            return;
          }
          const x = Math.round(Number(this.convertPxToPt(signBox.position.x + 2)));
          const y = Math.round(Number(this.convertPxToPt(signBox.position.y + 2)));
          const rect = this.constrainToA4Boundaries(x, y);
          if (!byPage.has(page)) {
            byPage.set(page, []);
          }
          byPage.get(page)!.push(rect);
        });
      });
    });
    return byPage;
  }

  private rectsOverlap(
    a: { x1: number; x2: number; y1: number; y2: number },
    b: { x1: number; x2: number; y1: number; y2: number },
  ): boolean {
    return a.x1 < b.x2 && b.x1 < a.x2 && a.y1 < b.y2 && b.y1 < a.y2;
  }

  updatePredefinedOptionState() {
    if (this.isDefaultSignatureSelected) {
        return; 
    }
    const partyDetails = this.partyDetailsArray().value;
    const selectedPositions = partyDetails
      .map((sign: any) => sign.sign_position)
      .filter((pos: any) => pos);
    const uniquePositions = new Set(selectedPositions);
    const isAllPredefinedUsed =
      uniquePositions.size >= this.displaySigningPositions.length;
    this.signPlacementNomal = [
      { name: 'Pre-Defined', value: 'NORMAL', disabled: isAllPredefinedUsed },
      { name: 'Custom (Drag & Drop)', value: 'DRAG_DROP', disabled: false },
      // { name: 'Default', value: DEFAULT, disabled: false },
    ];
  }

  showScheduleEmail(value: boolean) {
    this.displayMailSchedule = value;
    let scheduleMailYes = <HTMLInputElement>(
      document.getElementById('scheduleMailYes')
    );
    let scheduleMailNo = <HTMLInputElement>(
      document.getElementById('scheduleMailNo')
    );
    if (this.displayMailSchedule) {
      scheduleMailYes.checked = true;
      scheduleMailNo.checked = false;
      this.scheduleMailYes = true;
      this.scheduleMailNo = false;
      // this.hideOrderIndex();
    } else {
      this.hideScheduleEmail();
    }
  }

  hideScheduleEmail() {
    let scheduleMailYes = <HTMLInputElement>(
      document.getElementById('scheduleMailYes')
    );
    let scheduleMailNo = <HTMLInputElement>(
      document.getElementById('scheduleMailNo')
    );
    scheduleMailYes.checked = false;
    scheduleMailNo.checked = true;
    this.scheduleMailYes = false;
    this.scheduleMailNo = true;
    this.displayMailSchedule = false;
  }

  showOrderIndex(value: boolean) {
    this.displayOrderIndex = value;
    let orderSortYes = <HTMLInputElement>(
      document.getElementById('orderSortYes')
    );
    let orderSortNo = <HTMLInputElement>document.getElementById('orderSortNo');
    if (this.displayOrderIndex) {
      orderSortYes.checked = true;
      orderSortNo.checked = false;
      this.orderSortYes = true;
      this.orderSortNo = false;
      this.hideScheduleEmail();
    } else {
      this.hideOrderIndex();
    }
  }

  hideOrderIndex() {
    let orderSortYes = <HTMLInputElement>(
      document.getElementById('orderSortYes')
    );
    let orderSortNo = <HTMLInputElement>document.getElementById('orderSortNo');
    orderSortYes.checked = false;
    orderSortNo.checked = true;
    this.orderSortYes = false;
    this.orderSortNo = true;
    this.displayOrderIndex = false;
  }

  onDateSelected(i: number) {
    const partyDetails = this.partyDetailsArray().value[i];
    const date = partyDetails.schedule_timestamp;

    this.minDate[i + 1] = this.minDate[0];

    const selectedDateTime = new Date(date);
    const minDateTime = new Date(this.minDate[i]);
    if (selectedDateTime < minDateTime) {
      this.scheduleError[i] = true;
      this.selectedDateValue[i] = moment(new Date(this.minDate[i])).format(
        'lll',
      );
    } else {
      this.scheduleError[i] = false;
    }
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = this.padZero(date.getMonth() + 1);
    const day = this.padZero(date.getDate());
    const hours = this.padZero(date.getHours());
    const minutes = this.padZero(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  formatDateEnd(date: Date): string {
    const endDate = new Date(date);
    // Add one month to the date
    endDate.setFullYear(endDate.getFullYear() + 1);

    // Extract year, month, day, hours, and minutes
    const year = endDate.getFullYear();
    const month = this.padZero(endDate.getMonth() + 1);
    const day = this.padZero(endDate.getDate());
    const hours = this.padZero(endDate.getHours());
    const minutes = this.padZero(endDate.getMinutes());

    // Format the date
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  private padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  tobeDefault(value: boolean) {
    this.isDefault = value;
    if (this.isDefault) {
      this.default = true;
      this.custom = false;
      this.getDefaultFieldData(this.account_id);
    } else {
      this.default = false;
      this.custom = true;

      const formArray = this.esignDetails.get(
        'addPartyDetailsForm',
      ) as FormArray;
      formArray.controls.forEach((control) => {
        control.patchValue({
          name: '',
          email: '',
          contact_number: '',
          method: '',
          sign_position: '',
          aadhaar_digits: ''
        });
      });
    }
  }

  numberOnlyForContact(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (
      (event.keyCode != 8 && !pattern.test(inputChar)) ||
      event.keyCode == 45
    ) {
      event.preventDefault();
    } else if (event.target.value === '0') {
      event.preventDefault();
    }
  }

  numberOnlyForAdhar(event: KeyboardEvent): boolean {
    const isNumber = event.key >= '0' && event.key <= '9';
    const input = event.target as HTMLInputElement;
    if (!isNumber) {
      return false;
    }
    const selectedLength = (input.selectionEnd || 0) - (input.selectionStart || 0);
    const newLength = input.value.length - selectedLength + 1;
    return newLength <= 4;
  }
  setCarbonCopy(value: boolean) {
    this.isCarbonCopy = value;
    let carboncopyYes = <HTMLInputElement>(
      document.getElementById('carboncopyYes')
    );
    let carboncopyNo = <HTMLInputElement>(
      document.getElementById('carboncopyNo')
    );
    if (this.isCarbonCopy) {
      carboncopyYes.checked = true;
      carboncopyNo.checked = false;
      this.carboncopyYes = true;
      this.carboncopyNo = false;
    } else {
      this.hideCarbonCopy();
    }
  }

  hideCarbonCopy() {
    let carboncopyYes = <HTMLInputElement>(
      document.getElementById('carboncopyYes')
    );
    let carboncopyNo = <HTMLInputElement>(
      document.getElementById('carboncopyNo')
    );
    carboncopyYes.checked = false;
    carboncopyNo.checked = true;
    this.carboncopyYes = false;
    this.carboncopyNo = true;
    this.isCarbonCopy = false;
  }
  /**
   * Check if any email fields have invalid email format
   */
  hasInvalidEmails(): boolean {
    if (!this.isCarbonCopy) return false;

    const controls = this.getCarbonCopyControls();
    return controls.some((control) => {
      if (!control.value) return false;

      // Check for both email validator error and pattern validator error
      const hasEmailError = control.hasError('email');
      const hasPatternError = control.hasError('pattern');

      return (hasEmailError || hasPatternError) && control.touched;
    });
  }

  /**
   * Check if there are duplicate email addresses
   */
  hasDuplicateEmails(): boolean {
    if (!this.isCarbonCopy) return false;

    const controls = this.getCarbonCopyControls();
    const emails = controls
      .map((control) => control.value)
      .filter((email) => email && email.trim() !== '');

    if (emails.length <= 1) return false;

    const uniqueEmails = new Set(
      emails.map((email) => email.toLowerCase().trim()),
    );
    return emails.length > uniqueEmails.size;
  }

  /**
   * TrackBy function for carbon copy controls to improve performance
   */
  trackByCarbonCopy(index: number, item: any): number {
    return index;
  }
  /**
   * Get all carbon copy form controls (simplified for better performance)
   * @returns Array of form controls for carbon copy emails
   */
  getCarbonCopyControls(): AbstractControl[] {
    const controls: AbstractControl[] = [];

    // Only check for controls that exist based on our count
    for (let i = 0; i < this.carbonCopyControlsCount; i++) {
      const control = this.esignDetails.get(`carbon_copy_${i}`);
      if (control) {
        controls.push(control);
      }
    }

    return controls;
  }
  /**
   * Add a new carbon copy email field
   */
  addCarbonCopy(): void {
    const newIndex = this.activeCarbonCopyControls.length;
    const controlName = `carbon_copy_${newIndex}`;

    // Add the new control
    const newControl = new FormControl('', [
      Validators.required,
      Validators.email,
    ]);
    this.esignDetails.addControl(controlName, newControl);

    // Track the new control
    this.activeCarbonCopyControls.push(controlName);

    // Update carbonCopyControlsCount to match active controls
    this.carbonCopyControlsCount = this.activeCarbonCopyControls.length;
  }

  /**
   * Remove a carbon copy email field (specifically the second one)
   * @param index - Index of the field to remove
   */
  removeCarbonCopy(index: number): void {
    const controlName = `carbon_copy_${index}`;

    // Remove the form control completely
    if (this.esignDetails.get(controlName)) {
      this.esignDetails.removeControl(controlName);
    }

    // Remove from active controls tracking
    this.activeCarbonCopyControls = this.activeCarbonCopyControls.filter(
      (name) => name !== controlName,
    );

    // Update count
    this.carbonCopyControlsCount = this.activeCarbonCopyControls.length;

    // Clear any validation errors that might be lingering
    this.esignDetails.updateValueAndValidity();

    // Force a validation check
    this.forceValidationUpdate();
  }
  /**
   * Setup subscription to watch for setCarbonCopy changes
   */
  private setupCarbonCopySubscription(): void {
    this.esignDetails.get('setCarbonCopy')?.valueChanges.subscribe((value) => {
      this.isCarbonCopy = value;
      this.updateCarbonCopyValidation();
    });
  }
  /**
   * Update carbon copy field validation based on isCarbonCopy status
   */
  private updateCarbonCopyValidation(): void {
    const carbon_copy_0 = this.esignDetails.get('carbon_copy_0');

    if (this.isCarbonCopy) {
      // Add required and email validators when carbon copy is enabled
      carbon_copy_0?.setValidators([Validators.required, Validators.email]);
    } else {
      // Remove validators when carbon copy is disabled
      carbon_copy_0?.setValidators([]);
      // Clear all carbon copy fields
      this.clearAllCarbonCopyEmails();
    }

    carbon_copy_0?.updateValueAndValidity();

    // Update any additional carbon copy fields
    for (let i = 1; i < this.carbonCopyControlsCount; i++) {
      const controlName = `carbon_copy_${i}`;
      const control = this.esignDetails.get(controlName);
      if (control) {
        if (this.isCarbonCopy) {
          control.setValidators([Validators.required, Validators.email]);
        } else {
          control.setValidators([]);
        }
        control.updateValueAndValidity();
      }
    }
  }
  /**
   * Clear all carbon copy email fields
   */
  clearAllCarbonCopyEmails(): void {
    // Remove all controls except the first one
    for (let i = this.carbonCopyControlsCount - 1; i > 0; i--) {
      this.esignDetails.removeControl(`carbon_copy_${i}`);
    }

    // Clear the first control's value and reset count
    this.esignDetails.get('carbon_copy_0')?.setValue('');
    this.carbonCopyControlsCount = 1;
  }
  /**
   * Force validation update
   */
  private forceValidationUpdate(): void {
    // Use setTimeout to ensure the DOM and form state are updated
    setTimeout(() => {
      // Update validation for all remaining controls
      this.activeCarbonCopyControls.forEach((controlName) => {
        const control = this.esignDetails.get(controlName);
        if (control) {
          control.updateValueAndValidity();
        }
      });

      // Force form validation
      this.esignDetails.updateValueAndValidity();

      // Check place order status
      this.getActivePlaceOrder();
    }, 10);
  }

  // AutoSignature Conditions

  canSelectAutoSignature(): boolean {
    const totalSignatories = this.partyDetailsArray().length;
    const yesCount = this.getAutoSignatureYesCount();

    // Don't allow if only 1 signatory
    if (totalSignatories <= 1) {
      return false;
    }

    // Allow selection only if we haven't reached maximum 10 AND at least one remains as NO
    return yesCount < 10 && yesCount < totalSignatories - 1;
  }

  // Count how many signatories have selected "YES" for auto signature
  getAutoSignatureYesCount(): number {
    let yesCount = 0;
    for (let i = 0; i < this.partyDetailsArray().length; i++) {
      const formGroup = this.partyDetailsArray().at(i);
      const autoSignValue = formGroup.get('server_side_siganture')?.value;
      if (autoSignValue === this.serverSideYes) {
        yesCount++;
      }
    }
    return yesCount;
  }

  onAutoSignatureChange(partyDetailsIndex: number, value: any) {
    const formGroup = this.partyDetailsArray().at(partyDetailsIndex);
    const currentValue = formGroup.get(
      AUTO_SIGNATURE_CONSTANTS.SERVER_SIDE_SIGNATURE,
    )?.value;

    if (currentValue === value) {
      return;
    }

    if (value === this.serverSideYes) {
      const totalSignatories = this.partyDetailsArray().length;
      const yesCount = this.getAutoSignatureYesCount();
      this.hideSequentialSignature = true;

      if (totalSignatories <= 1) {
        this.messageService.add({
          severity: AUTO_SIGNATURE_CONSTANTS.SEVERITY_ERROR,
          summary: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_NOT_AVAILABLE,
          detail: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_MIN_SIGNATORY,
        });
        return;
      }

      if (yesCount >= 10) {
        this.messageService.add({
          severity: AUTO_SIGNATURE_CONSTANTS.SEVERITY_ERROR,
          summary: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_LIMIT,
          detail: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_MAX_LIMIT,
        });
        return;
      }

      if (yesCount >= totalSignatories - 1) {
        this.messageService.add({
          severity: AUTO_SIGNATURE_CONSTANTS.SEVERITY_ERROR,
          summary: AUTO_SIGNATURE_CONSTANTS.MANUAL_SIGNER_REQUIRED,
          detail: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_MANUAL_REQUIRED,
        });
        return;
      }
    } else {
      this.hideSequentialSignature = false;
    }

    formGroup
      .get(AUTO_SIGNATURE_CONSTANTS.SERVER_SIDE_SIGNATURE)
      ?.setValue(value);
  }

  canThisSignatorySelectYes(partyDetailsIndex: number): boolean {
    const formGroup = this.partyDetailsArray().at(partyDetailsIndex);
    const currentValue = formGroup.get(
      AUTO_SIGNATURE_CONSTANTS.SERVER_SIDE_SIGNATURE,
    )?.value;

    const totalSignatories = this.partyDetailsArray().length;
    const yesCount = this.getAutoSignatureYesCount();

    if (currentValue === this.serverSideYes) {
      return true;
    }

    return (
      totalSignatories > 1 && yesCount < 10 && yesCount < totalSignatories - 1
    );
  }

  handleYesRadioClick(partyDetailsIndex: number, event?: Event) {
    const formGroup = this.partyDetailsArray().at(partyDetailsIndex);
    const currentValue = formGroup.get(
      AUTO_SIGNATURE_CONSTANTS.SERVER_SIDE_SIGNATURE,
    )?.value;

    if (currentValue === this.serverSideYes) {
      event?.preventDefault();
      event?.stopPropagation();
      return;
    }

    if (this.canThisSignatorySelectYes(partyDetailsIndex)) {
      this.onAutoSignatureChange(partyDetailsIndex, this.serverSideYes);
    } else {
      event?.preventDefault();
      event?.stopPropagation();

      const totalSignatories = this.partyDetailsArray().length;
      const yesCount = this.getAutoSignatureYesCount();

      if (totalSignatories <= 1) {
        this.messageService.add({
          severity: AUTO_SIGNATURE_CONSTANTS.SEVERITY_ERROR,
          summary: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_NOT_AVAILABLE,
          detail: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_MIN_SIGNATORY,
        });
      } else if (yesCount >= 10) {
        this.messageService.add({
          severity: AUTO_SIGNATURE_CONSTANTS.SEVERITY_ERROR,
          summary: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_LIMIT,
          detail: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_MAX_LIMIT,
        });
      } else if (yesCount >= totalSignatories - 1) {
        this.messageService.add({
          severity: AUTO_SIGNATURE_CONSTANTS.SEVERITY_ERROR,
          summary: AUTO_SIGNATURE_CONSTANTS.MANUAL_SIGNER_REQUIRED,
          detail: AUTO_SIGNATURE_CONSTANTS.AUTO_SIGNATURE_MANUAL_REQUIRED,
        });
      }
    }
  }

  checkAndPopulateDraft() {
    const draftData = this.storageService.getDraftData();
    if (!draftData) return;

    if (!this.currentOrderId && draftData?.order?.id) {
      this.currentOrderId = draftData.order.id;
    }
    // Strict check: only populate if the IDs match
    if (draftData?.order?.id === this.currentOrderId) {
      this.populateEsignFormWithDraft(draftData);
    }
  }

  populateEsignFormWithDraft(data: any) {
    this.isDraftLoading = true;

    if (data.esign && data.esign.length > 0) {
      const partyArray = this.partyDetailsArray();
      while (partyArray.length !== 0) {
        partyArray.removeAt(0);
      }

      // Populate from Draft
      data.esign.forEach((esignEntry: any, index: number) => {
        // Initialize a new group
        partyArray.push(this.initPartyDetails('PARTY'));
        const formGroup = partyArray.at(index);
        // Patch Values (Mapping JSON keys to Form keys)
        formGroup.patchValue(
          {
            name: esignEntry.name,
            email: esignEntry.email,
            contact_number: esignEntry.contact_number,
            method: esignEntry.sign_method,
            pages: esignEntry.pages || 'ALL',
            remark: esignEntry.email_remark,
            sign_position: esignEntry.sign_position,
            aadhaar_digits: esignEntry.aadhaar_digits,
            sign_mode: esignEntry.sign_mode,
            signatory_sequence: esignEntry.signatory_sequence || index + 1,
          },
          { emitEvent: false },
        );

        if (esignEntry.sign_position === 'DRAG_DROP') {
          formGroup.get('signature_placement_type')?.setValue('DRAG_DROP');
          this.showPredefined[index] = false;
          //this.showSelectPage[index] = false;
          if (esignEntry.position_details) {
            formGroup
              .get('position_details')
              ?.setValue(esignEntry.position_details);
          }
        } else if (esignEntry.sign_position === 'NORMAL') {
          formGroup.get('signature_placement_type')?.setValue('NORMAL');
          this.showPredefined[index] = true;
          //this.showSelectPage[index] = true;
        }
        else{
          formGroup.get('signature_placement_type')?.setValue('DEFAULT');
          this.showPredefined[index] = false;
          //this.showSelectPage[index] = true;
        }
      });
      // Trigger UI updates
      this.rebuildSignatoryPositions();
      this.cdr?.detectChanges();
      setTimeout(() => {
        this.isDraftLoading = false;
      }, 1000);
    }
  }
  private swapSignatureStates(indexA: number, indexB: number): void {
    const stateA = this.signatureStateService.getSignatureState(indexA);
    const stateB = this.signatureStateService.getSignatureState(indexB);

    // Swap state A → B
    if (stateB) {
      this.signatureStateService.updateSignatureState(
        indexA,
        stateB.hasSignatures,
        stateB.signatureCount,
      );
    } else {
      this.signatureStateService.clearSignatureState(indexA);
    }

    // Swap state B → A
    if (stateA) {
      this.signatureStateService.updateSignatureState(
        indexB,
        stateA.hasSignatures,
        stateA.signatureCount,
      );
    } else {
      this.signatureStateService.clearSignatureState(indexB);
    }

    // Swap signPlacementDetails entries at these indices
    Object.keys(this.signPlacementDetails).forEach((pageNumber) => {
      const pageArray = this.signPlacementDetails[pageNumber];
      if (pageArray && Array.isArray(pageArray)) {
        const temp = pageArray[indexA];
        pageArray[indexA] = pageArray[indexB];
        pageArray[indexB] = temp;
      }
    });
  }
  private refreshDisplayStateOnly(i: number): void {
    const formGroup = this.partyDetailsArray().at(i);
    const currentPlacementType = formGroup.get(
      'signature_placement_type',
    )?.value;

    // Only update UI display flag — do NOT clear position_details or signature state
    this.showPredefined[i] = currentPlacementType === 'NORMAL';

    this.rebuildSignatoryPositions();
  }

  getAvailableProviders(): string[] {
    return this.storageService.getPaymentProviders();
  }

  hasProvider(provider: string): boolean {
    return this.getAvailableProviders().includes(provider);
  }
}
